export const CalenderIcon = ({ color = "#898989" }) => {
  return (
    <span className="icon calender">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_13711_4583)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.7494 5.25113V6.00038C12.7396 6.47963 12.2124 6.86888 11.7519 6.70688C11.4616 6.60488 11.2576 6.31088 11.2509 6.00038V5.25113H9.00386C8.42036 5.22338 8.03861 4.47263 8.43761 4.01138C8.54711 3.88538 8.69786 3.79838 8.86211 3.76688C8.92436 3.75488 8.94086 3.75638 9.00386 3.75338H11.2509V3.00413C11.2539 2.88188 11.2651 2.84213 11.2884 2.77013C11.3881 2.46863 11.6949 2.25488 12.0151 2.25488C12.4119 2.27063 12.7404 2.56988 12.7494 3.00413V3.75338H17.2434V3.00413C17.2464 2.88188 17.2576 2.84213 17.2809 2.77013C17.3806 2.46863 17.6874 2.25488 18.0076 2.25488C18.4044 2.27063 18.7329 2.56988 18.7419 3.00413V3.75338H19.4934C19.5196 3.75338 19.5196 3.75338 19.5466 3.75413C20.6941 3.78938 21.7156 4.77713 21.7381 5.97263C21.7651 10.4771 21.7381 14.9816 21.7381 19.4854C21.7306 20.6471 20.7444 21.7076 19.5189 21.7301C14.5149 21.7609 9.51086 21.7309 4.50761 21.7309C3.33911 21.7234 2.28536 20.7191 2.26286 19.5116C2.23436 15.0071 2.26211 10.5026 2.26211 5.99813C2.26961 4.82663 3.28361 3.76088 4.50761 3.75338H5.25836V3.00413C5.26136 2.88188 5.27261 2.84213 5.29586 2.77013C5.39561 2.46863 5.70236 2.25488 6.02261 2.25488C6.14411 2.26013 6.18461 2.27213 6.25586 2.29763C6.54611 2.39963 6.75086 2.69363 6.75686 3.00413V6.00038C6.74711 6.47963 6.21986 6.86888 5.75936 6.70688C5.46911 6.60488 5.26511 6.31088 5.25836 6.00038V5.25038C5.00561 5.24963 4.75286 5.24963 4.50011 5.25113C4.11311 5.25863 3.76811 5.59988 3.76061 5.99138C3.73286 10.4914 3.73286 14.9921 3.76061 19.4929C3.76811 19.8806 4.10861 20.2249 4.50011 20.2324C9.50036 20.2631 14.5006 20.2631 19.5001 20.2324C19.8879 20.2249 20.2321 19.8844 20.2396 19.4929C20.2674 14.9921 20.2674 10.4914 20.2396 5.99063C20.2329 5.60213 19.8969 5.25413 19.4881 5.25113H18.7419V6.00038C18.7306 6.55163 18.0061 6.95663 17.5359 6.59363C17.3544 6.45413 17.2479 6.23138 17.2434 6.00038V5.25113H12.7494ZM6.00761 17.2361C6.42086 17.2361 6.75686 17.5721 6.75686 17.9854C6.75686 18.3986 6.42086 18.7346 6.00761 18.7346C5.59436 18.7346 5.25836 18.3986 5.25836 17.9854C5.25836 17.5721 5.59436 17.2361 6.00761 17.2361ZM9.00386 17.2361C9.41711 17.2361 9.75311 17.5721 9.75311 17.9854C9.75311 18.3986 9.41711 18.7346 9.00386 18.7346C8.59061 18.7346 8.25461 18.3986 8.25461 17.9854C8.25461 17.5721 8.59061 17.2361 9.00386 17.2361ZM12.0001 17.2361C12.4134 17.2361 12.7494 17.5721 12.7494 17.9854C12.7494 18.3986 12.4134 18.7346 12.0001 18.7346C11.5869 18.7346 11.2509 18.3986 11.2509 17.9854C11.2509 17.5721 11.5869 17.2361 12.0001 17.2361ZM6.00761 14.2399C6.42086 14.2399 6.75686 14.5759 6.75686 14.9891C6.75686 15.4024 6.42086 15.7384 6.00761 15.7384C5.59436 15.7384 5.25836 15.4024 5.25836 14.9891C5.25836 14.5759 5.59436 14.2399 6.00761 14.2399ZM9.00386 14.2399C9.41711 14.2399 9.75311 14.5759 9.75311 14.9891C9.75311 15.4024 9.41711 15.7384 9.00386 15.7384C8.59061 15.7384 8.25461 15.4024 8.25461 14.9891C8.25461 14.5759 8.59061 14.2399 9.00386 14.2399ZM12.0001 14.2399C12.4134 14.2399 12.7494 14.5759 12.7494 14.9891C12.7494 15.4024 12.4134 15.7384 12.0001 15.7384C11.5869 15.7384 11.2509 15.4024 11.2509 14.9891C11.2509 14.5759 11.5869 14.2399 12.0001 14.2399ZM14.9964 14.2399C15.4096 14.2399 15.7456 14.5759 15.7456 14.9891C15.7456 15.4024 15.4096 15.7384 14.9964 15.7384C14.5831 15.7384 14.2471 15.4024 14.2471 14.9891C14.2471 14.5759 14.5831 14.2399 14.9964 14.2399ZM17.9926 14.2399C18.4059 14.2399 18.7419 14.5759 18.7419 14.9891C18.7419 15.4024 18.4059 15.7384 17.9926 15.7384C17.5794 15.7384 17.2434 15.4024 17.2434 14.9891C17.2434 14.5759 17.5794 14.2399 17.9926 14.2399ZM9.00386 11.2436C9.41711 11.2436 9.75311 11.5796 9.75311 11.9929C9.75311 12.4061 9.41711 12.7421 9.00386 12.7421C8.59061 12.7421 8.25461 12.4061 8.25461 11.9929C8.25461 11.5796 8.59061 11.2436 9.00386 11.2436ZM12.0001 11.2436C12.4134 11.2436 12.7494 11.5796 12.7494 11.9929C12.7494 12.4061 12.4134 12.7421 12.0001 12.7421C11.5869 12.7421 11.2509 12.4061 11.2509 11.9929C11.2509 11.5796 11.5869 11.2436 12.0001 11.2436ZM14.9964 11.2436C15.4096 11.2436 15.7456 11.5796 15.7456 11.9929C15.7456 12.4061 15.4096 12.7421 14.9964 12.7421C14.5831 12.7421 14.2471 12.4061 14.2471 11.9929C14.2471 11.5796 14.5831 11.2436 14.9964 11.2436ZM17.9926 11.2436C18.4059 11.2436 18.7419 11.5796 18.7419 11.9929C18.7419 12.4061 18.4059 12.7421 17.9926 12.7421C17.5794 12.7421 17.2434 12.4061 17.2434 11.9929C17.2434 11.5796 17.5794 11.2436 17.9926 11.2436Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_13711_4583">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export const CalenderIcon1 = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="3"
        y="4"
        width="18"
        height="18"
        rx="2"
        ry="2"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="16"
        y1="2"
        x2="16"
        y2="6"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" />
      <line
        x1="3"
        y1="10"
        x2="21"
        y2="10"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const CalenderIcon2 = ({ color = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={color}
      className="bi bi-calendar-event-fill"
      viewBox="0 0 16 16"
    >
      <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5" />
    </svg>
  );
};

export const ClearCalenderIcon = () => {
  return (
    <span className="icon calender">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="#cd0909"
        className="bi bi-x-circle-fill"
        viewBox="0 0 16 16"
      >
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
      </svg>
    </span>
  );
};

export const ClearIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-check"
      viewBox="0 0 16 16"
    >
      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
    </svg>
  );
};

export const PendingIcon = (color = "#3474F1") => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0001 1.66699C8.35191 1.66699 6.74074 2.15573 5.37033 3.07141C3.99992 3.98709 2.93182 5.28858 2.30109 6.8113C1.67036 8.33401 1.50533 10.0096 1.82687 11.6261C2.14842 13.2426 2.94209 14.7274 4.10753 15.8929C5.27297 17.0583 6.75782 17.852 8.37433 18.1735C9.99084 18.4951 11.6664 18.3301 13.1891 17.6993C14.7118 17.0686 16.0133 16.0005 16.929 14.6301C17.8447 13.2597 18.3334 11.6485 18.3334 10.0003C18.3334 8.90598 18.1179 7.82234 17.6991 6.8113C17.2803 5.80025 16.6665 4.88159 15.8926 4.10777C15.1188 3.33395 14.2002 2.72012 13.1891 2.30133C12.1781 1.88254 11.0944 1.66699 10.0001 1.66699ZM10.8334 10.0003C10.8341 10.11 10.813 10.2187 10.7716 10.3202C10.7301 10.4218 10.669 10.5141 10.5918 10.592L8.09175 13.092C7.93233 13.2285 7.72727 13.2999 7.51754 13.2918C7.30781 13.2837 7.10886 13.1967 6.96045 13.0483C6.81204 12.8999 6.72509 12.7009 6.71699 12.4912C6.70889 12.2815 6.78023 12.0764 6.91675 11.917L9.16675 9.65866V5.83366C9.16675 5.61265 9.25455 5.40068 9.41083 5.2444C9.56711 5.08812 9.77907 5.00033 10.0001 5.00033C10.2211 5.00033 10.4331 5.08812 10.5893 5.2444C10.7456 5.40068 10.8334 5.61265 10.8334 5.83366V10.0003Z"
        fill={color}
      />
    </svg>
  );
};

export const ExpectedIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
          fill="#f54242"
        />
        <path
          d="M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10m0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12"
          fill="#f5a742"
        />
        <path
          d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
          fill="#42f554"
        />
        <path d="M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" fill="#425af5" />
      </svg>
    </>
  );
};

export const CompletedIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 1.875C5.51172 1.875 1.875 5.51172 1.875 10C1.875 14.4883 5.51172 18.125 10 18.125C14.4883 18.125 18.125 14.4883 18.125 10C18.125 5.51172 14.4883 1.875 10 1.875ZM8.74609 12.8789C8.65234 12.9727 8.51953 13.0508 8.40234 13.0508C8.28516 13.0508 8.15234 12.9688 8.05469 12.875L5.86719 10.6875L6.5625 9.99219L8.40625 11.8359L13.2812 6.92578L13.9648 7.63281L8.74609 12.8789Z"
          fill="#379C00"
        />
      </svg>
    </>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-arrows-angle-expand"
      viewBox="0 0 16 16"
      style={{
        color: "#bc0909",
        width: "20px",
        height: "20px",
      }}
    >
      <path
        fillRule="evenodd"
        d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      className="bi bi-x-circle-fill"
      viewBox="0 0 16 16"
      style={{ color: "#E41815" }}
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    </svg>
  );
};

export const ReopenIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12a9 9 0 11-3-6.74" />
      <path d="M21 3v6h-6" />
    </svg>
  );
};

export const RightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      className="bi bi-check-circle-fill"
      viewBox="0 0 16 16"
      style={{ color: "#209216" }}
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
  );
};

export const DownloadIcon = ({ size = 24, color = "Blue" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill={color}
    >
      <path
        fillRule="evenodd"
        d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
      />
      <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
    </svg>
  );
};

export const CallIcon = ({ color = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={color}
      className="bi bi-telephone-fill"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
      />
    </svg>
  );
};

export const CallIcon1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.48839 10.2428C9.73698 12.4384 11.5626 14.264 13.7582 15.5125L14.9375 13.8615C15.3296 13.3127 16.0698 13.1431 16.6618 13.4664C18.5375 14.4911 20.6104 15.1137 22.7728 15.2849C23.4663 15.3399 24.001 15.9185 24.001 16.6141V22.5645C24.001 23.2481 23.4839 23.8209 22.8039 23.8908C22.0974 23.9635 21.3846 24 20.6676 24C9.25376 24 0.000976562 14.7472 0.000976562 3.33333C0.000976562 2.61636 0.0375367 1.90361 0.110163 1.19701C0.180043 0.517 0.752897 0 1.43651 0H7.38687C8.08244 0 8.66115 0.53472 8.71604 1.22812C8.8872 3.39051 9.50991 5.46352 10.5346 7.33925C10.8579 7.9312 10.6883 8.67139 10.1395 9.06343L8.48839 10.2428ZM5.12664 9.36693L7.65991 7.55745C6.9416 6.00685 6.44935 4.36244 6.19734 2.66667H2.67974C2.67168 2.88843 2.66764 3.11067 2.66764 3.33333C2.66764 13.2744 10.7266 21.3333 20.6676 21.3333C20.8903 21.3333 21.1126 21.3293 21.3343 21.3212V17.8036C19.6386 17.5516 17.9942 17.0593 16.4435 16.3411L14.634 18.8744C13.902 18.59 13.1951 18.2553 12.5175 17.8748L12.44 17.8307C9.82724 16.3449 7.6561 14.1737 6.17031 11.5609L6.12623 11.4835C5.74563 10.8059 5.41103 10.0989 5.12664 9.36693Z"
        fill="white"
      />
    </svg>
  );
};

export const EmailIcon = ({ color = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={color}
      className="bi bi-envelope-fill"
      viewBox="0 0 16 16"
    >
      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
    </svg>
  );
};

export const ChevronIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

export const CheckCircleIcon = ({ color = "#209216" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-check-circle-fill"
    viewBox="0 0 16 16"
    style={{ color: color }}
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
);

export const DoubleCheckIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-check-all"
    viewBox="0 0 16 16"
    style={{ color: color }}
  >
    <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486z" />
  </svg>
);

export const CrossCircleIcon = ({ color = "#E41815" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x-circle-fill"
      viewBox="0 0 16 16"
      style={{ color: color }}
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    </svg>
  );
};

export const ExchangeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 16V4M7 4L3 8M7 4L11 8"></path>
    <path d="M17 8v12M17 20l4-4M17 20l-4-4"></path>
  </svg>
);

export const ClockIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="24"
    height="24"
    style={{ flexShrink: 0 }}
  >
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

export const UpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-chevron-up"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
    />
  </svg>
);

export const DownIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-chevron-down"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
    />
  </svg>
);

export const EyeIcon = ({ color = "#000" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={color}
      className="bi bi-eye-fill"
      viewBox="0 0 16 16"
    >
      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
    </svg>
  );
};

export const EyeIconNoFill = ({ color = "#000" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={color}
      className="bi bi-eye"
      viewBox="0 0 16 16"
    >
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
    </svg>
  );
};

export const XCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-x-circle-fill"
    viewBox="0 0 16 16"
    style={{ color: "#E41815", cursor: "not-allowed" }}
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
  </svg>
);

export const CloudUploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
  >
    <path
      d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
      fill="#A5A5A5"
    />
    <path
      d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
      fill="#A5A5A5"
    />
  </svg>
);

export const UploadIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-upload"
    viewBox="0 0 16 16"
    style={{ color: color }}
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
  </svg>
);

export const CloudPlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-cloud-plus"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
    />
    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-x"
    viewBox="0 0 16 16"
  >
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
  </svg>
);

export const YesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      fill="#22c55e"
      stroke="#16a34a"
      strokeWidth="1"
    />
    <path
      d="M6 10.2l2.5 2.5L14 7.2"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <circle
      cx="10"
      cy="10"
      r="9"
      fill="#ef4444"
      stroke="#dc2626"
      strokeWidth="1"
    />
    <path
      d="M7 7l6 6M13 7l-6 6"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ReloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="currentColor"
    className="lead-v2-reload-icon"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
    />
    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
  </svg>
);

export const RupeeIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-currency-rupee card-svg"
    viewBox="0 0 16 16"
  >
    <path d="M4 3.06h2.726c1.22 0 2.12.575 2.325 1.724H4v1.051h5.051C8.855 7.001 8 7.558 6.788 7.558H4v1.317L8.437 14h2.11L6.095 8.884h.855c2.316-.018 3.465-1.476 3.688-3.049H12V4.784h-1.345c-.08-.778-.357-1.335-.793-1.732H12V2H4z" />
  </svg>
);

export const DollarIcon = ({ color = "#000" }) => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrendingUpIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <path
      d="m3 17 6-6 4 4 8-8"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m21 9-8 8-4-4-6 6"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserIcon = ({ color = "#fff" }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 24 24"
    fill="none"
    style={{ fill: color }}
  >
    <path
      d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="2" />
    <path
      d="m22 21-3-3M15 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0z"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

export const ClockIconV2 = ({ color = "#000" }) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
    <path
      d="M12 6v6l4 2"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIconV3 = ({ color = "#000" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" fill={color} />
    <path
      d="M12 6v6l4 2"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#ef4444"
    className="bi bi-exclamation-triangle"
    viewBox="0 0 16 16"
  >
    <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
    <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
  </svg>
);

export const CheckIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-check2-circle"
    viewBox="0 0 16 16"
  >
    <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
    <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
  </svg>
);

export const HourglassIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-exclamation-triangle-fill"
    viewBox="0 0 16 16"
  >
    <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
  </svg>
);

export const PersonIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-person-fill"
    viewBox="0 0 16 16"
  >
    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
  </svg>
);

export const PersonIcon1 = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" />
  </svg>
);

export const TargetIcon = ({ color = "#111827" }) => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" />
    <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="2" />
    <circle cx="12" cy="12" r="2" fill={color} />
  </svg>
);

export const EditIcon1 = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-pencil"
    viewBox="0 0 16 16"
  >
    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
  </svg>
);

export const EditIcon2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-pencil-fill"
    viewBox="0 0 16 16"
    style={{
      color: "#c71010",
      cursor: "pointer",
    }}
  >
    <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
  </svg>
);

export const BinIcon1 = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-trash3"
    viewBox="0 0 16 16"
  >
    <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
  </svg>
);

export const BinIcon2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-trash3-fill"
    viewBox="0 0 16 16"
    style={{
      color: "#c71010",
      cursor: "pointer",
    }}
  >
    <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
  </svg>
);

export const CalendarIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-calendar-event"
    viewBox="0 0 16 16"
  >
    <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
  </svg>
);

export const WhatsAppIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-whatsapp"
    viewBox="0 0 16 16"
  >
    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
  </svg>
);

export const ChartIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-bar-chart-line-fill"
    viewBox="0 0 16 16"
  >
    <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1z" />
  </svg>
);

export const BiChartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-bar-chart-fill card-svg"
    viewBox="0 0 16 16"
  >
    <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z" />
  </svg>
);

export const DiagramIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-diagram-3-fill"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5z"
    />
  </svg>
);

export const HoldingMoneyIcon = ({ color = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-clippath="url(#clip0_13711_4636)">
      <path
        d="M20.7787 14.7141C21.028 14.8354 21.2329 15.1987 21.2258 15.4767C21.2206 15.6336 21.1438 15.7528 21.0332 15.8366C20.92 15.9195 20.7876 15.9723 20.6484 15.9899C20.0944 16.0701 19.5399 16.1394 18.984 16.2126V16.2144C18.453 16.2857 17.9201 16.3606 17.3876 16.4263C17.2254 16.446 17.0792 16.4263 16.9564 16.3729C16.6536 16.2426 16.4896 15.9201 16.5786 15.5301C16.6428 15.2485 16.8191 15.0759 17.1275 15.0347C18.1146 14.8974 19.1035 14.7568 20.0962 14.6428C20.3226 14.6176 20.5682 14.6105 20.7787 14.7141Z"
        fill={color}
      />
      <path
        d="M16.8585 21.7078C16.8336 21.7594 16.8139 21.8076 16.798 21.8522C16.5931 22.4277 16.6855 23.0052 17.0618 23.4753C17.0815 23.5002 17.1026 23.5251 17.1223 23.5484C16.6109 23.609 16.0973 23.6482 15.5826 23.6661C14.7024 23.6928 13.7973 23.6501 12.9382 23.4468C12.1471 23.2616 11.4164 22.8534 10.6059 22.7536C9.98766 22.6753 9.36051 22.6593 8.73856 22.6504C8.26801 22.6433 7.88504 22.2689 7.82789 21.8021L7.06715 15.617C7.04174 15.408 7.08502 15.1964 7.19045 15.0141C7.29589 14.8318 7.45775 14.6888 7.65162 14.6066C8.12817 14.4066 8.58261 14.1576 9.0076 13.8636C10.312 12.9548 12.6035 11.0697 14.207 10.6581C15.9459 10.211 17.4377 11.214 19.1091 11.4938C19.6135 11.5792 20.6221 11.6204 20.6592 12.3117C20.7234 13.5697 19.1448 13.7924 18.2074 13.8191C17.6096 13.8367 17.0116 13.7907 16.4235 13.6818C16.2651 13.6532 15.8944 13.484 15.7463 13.5196C15.6965 13.5316 15.6493 13.5528 15.6071 13.582C15.249 13.8243 15.2739 14.398 15.1473 14.765C14.9674 15.2782 14.6646 15.8126 14.3402 16.2245C13.8251 16.8821 12.9646 17.7802 12.0665 18.044C12.045 18.051 12.0328 18.0744 12.0417 18.0937C12.0444 18.1017 12.0498 18.1086 12.0569 18.1131C12.0641 18.1176 12.0726 18.1196 12.081 18.1186C13.7951 17.9813 15.0015 16.6609 15.7374 15.2107C15.7392 15.2088 15.7426 15.207 15.7444 15.2055C15.7305 15.2477 15.7186 15.2906 15.7088 15.3339C15.6001 15.8096 15.6873 16.2854 15.9474 16.6561C15.5875 16.8858 15.3381 17.2654 15.2687 17.7252C15.1922 18.2277 15.3203 18.7001 15.6268 19.0563C15.7552 19.2059 15.9066 19.3254 16.074 19.4144C16.0142 19.5273 15.9681 19.6469 15.9367 19.7707C15.8083 20.2928 15.917 20.8417 16.2287 21.2406C16.3923 21.4507 16.61 21.6122 16.8585 21.7078Z"
        fill={color}
      />
      <path
        d="M20.6394 1.68086C20.661 1.03664 20.2413 0.582048 19.5915 0.560525C17.474 0.482595 15.3098 0.402439 13.1589 0.32822C13.0604 0.320944 12.9613 0.326809 12.8643 0.345662C12.3588 0.449197 12.0486 0.841443 12.023 1.39771C11.9506 3.47806 11.8924 5.05113 11.8241 6.96375L11.7851 8.01765L11.7324 9.06971C11.6972 9.76068 11.6623 10.4064 11.6289 11.0487C12.0894 10.678 12.6008 10.3559 13.1845 10.1492C13.2198 9.4408 13.2547 8.76355 13.2899 8.08445C13.333 6.86281 13.3779 5.64896 13.4265 4.25551C13.4635 4.24615 13.5 4.23513 13.536 4.22248L13.5905 4.20504C14.332 4.01578 14.8121 3.54746 14.9899 2.80193C15.9637 2.8409 16.7953 2.8665 17.5701 2.89359C17.7456 3.68773 18.2474 4.22248 19.0319 4.45293C18.9732 5.95957 18.9305 7.1775 18.8912 8.26258L18.8871 8.33086L18.8853 8.39914C18.8482 9.12722 18.8051 9.91543 18.7602 10.8135C18.9573 10.8643 19.1525 10.9092 19.3477 10.9422C19.41 10.9519 19.4805 10.9619 19.5544 10.9716C19.7262 10.9968 19.9778 11.032 20.2531 11.1022L20.4112 7.96793L20.4131 7.96607L20.419 7.83545L20.4268 7.6833L20.4249 7.68144L20.6394 1.68086Z"
        fill={color}
      />
      <path
        d="M16.0636 9.85516C16.9742 9.85516 17.7123 9.11698 17.7123 8.20639C17.7123 7.2958 16.9742 6.55762 16.0636 6.55762C15.153 6.55762 14.4148 7.2958 14.4148 8.20639C14.4148 9.11698 15.153 9.85516 16.0636 9.85516Z"
        fill={color}
      />
      <path
        d="M16.0636 9.85516C16.9742 9.85516 17.7123 9.11698 17.7123 8.20639C17.7123 7.2958 16.9742 6.55762 16.0636 6.55762C15.153 6.55762 14.4148 7.2958 14.4148 8.20639C14.4148 9.11698 15.153 9.85516 16.0636 9.85516Z"
        fill={color}
      />
      <path
        d="M8.9159 1.975C8.81963 1.99898 8.72657 2.03436 8.63869 2.08039C8.18967 2.33199 8.01043 2.79846 8.15478 3.33729C8.71291 5.34342 9.13261 6.86008 9.64398 8.70441L9.92713 9.72121L10.1906 10.7421C10.3116 11.1989 10.4248 11.6361 10.5379 12.0654C10.6181 11.9834 10.6997 11.8995 10.784 11.8175C10.8074 11.3804 10.8307 10.9492 10.8523 10.5098L10.981 7.9767L10.9851 7.91213C10.784 7.18998 10.5791 6.44445 10.3546 5.63844C10.3899 5.61877 10.417 5.59762 10.4504 5.57387L10.4971 5.5427C10.7432 5.38869 10.9402 5.20908 11.0887 5.00201C11.1317 3.85051 11.1725 2.71682 11.2215 1.37012C11.2234 1.35824 11.2215 1.34488 11.2234 1.33301C10.4541 1.54564 9.68295 1.76051 8.9159 1.975ZM6.46668 23.1852L3.83043 23.5096C3.66509 23.5299 3.49844 23.4838 3.36712 23.3813C3.2358 23.2787 3.15057 23.1283 3.13017 22.9629L2.16681 15.1318C2.14647 14.9664 2.19263 14.7998 2.29513 14.6684C2.39764 14.5371 2.5481 14.4519 2.71343 14.4315L5.34969 14.1072C5.51503 14.0868 5.68168 14.133 5.81299 14.2355C5.94431 14.338 6.02954 14.4885 6.04994 14.6538L7.0133 22.4846C7.02347 22.5665 7.0174 22.6496 6.99543 22.7292C6.97346 22.8087 6.93601 22.8832 6.88525 22.9482C6.83448 23.0133 6.77138 23.0677 6.69955 23.1084C6.62773 23.1491 6.5486 23.1752 6.46668 23.1852ZM20.8091 22.6787C20.5081 22.7715 20.1942 22.8268 19.8825 22.8854C19.3997 22.9745 18.915 23.0528 18.4304 23.1385C18.1665 23.1849 17.9316 23.1366 17.7568 22.9192C17.5731 22.6876 17.5394 22.4275 17.6373 22.151C17.7264 21.905 17.9242 21.791 18.1684 21.7465C18.2237 21.7357 18.3109 21.7216 18.4196 21.7038C18.4233 21.7038 18.4267 21.702 18.4304 21.702C19.0186 21.6021 20.2246 21.4081 20.6079 21.3687C20.6473 21.365 20.6844 21.3617 20.7185 21.3617H20.7237C20.7256 21.3617 20.7274 21.3617 20.7289 21.3598C21.0748 21.3528 21.2403 21.4827 21.2848 21.7287C21.3594 22.1425 21.1601 22.5718 20.8091 22.6787ZM21.0622 20.3946C20.9089 20.4232 20.7538 20.4518 20.599 20.4766C20.0769 20.5675 19.5514 20.6425 19.0275 20.7208C18.7888 20.7564 18.548 20.7883 18.3075 20.8206C18.2916 20.8225 18.2738 20.8243 18.256 20.8277C18.0352 20.8562 17.8121 20.8848 17.5895 20.9167C16.9196 21.0128 16.6933 20.4269 16.802 19.9868C16.8554 19.7712 16.9872 19.6394 17.169 19.5697H17.1709C17.2351 19.5429 17.3045 19.527 17.3776 19.5162C17.9691 19.4342 18.5606 19.3541 19.1521 19.2739C19.7366 19.1937 20.3192 19.1136 20.9037 19.0353C20.9946 19.0227 21.0785 19.0212 21.1549 19.0264H21.1568C21.4544 19.0479 21.6485 19.1993 21.693 19.4487C21.7728 19.9081 21.5271 20.307 21.0622 20.3946ZM21.837 17.303C21.8121 17.843 21.6251 18.0567 21.0922 18.135C21.0885 18.135 21.0833 18.1369 21.0781 18.1369C20.4046 18.2315 19.7273 18.3221 19.052 18.413C18.3587 18.5091 17.6655 18.607 16.9709 18.6961C16.9671 18.6961 16.9638 18.698 16.9601 18.698C16.9193 18.7032 16.8781 18.705 16.8387 18.705C16.3756 18.705 16.0762 18.3469 16.1493 17.8586C16.1956 17.5609 16.3897 17.3509 16.7018 17.306C16.7623 17.2971 16.8246 17.2882 16.8855 17.2811C18.2264 17.0931 19.5682 16.9114 20.9108 16.736C21.0195 16.7219 21.1316 16.7234 21.244 16.7379C21.3134 16.7449 21.3832 16.7575 21.4507 16.7716C21.7194 16.8273 21.8496 17.0232 21.837 17.303Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_13711_4636">
        <rect
          width="23.75"
          height="23.75"
          fill={color}
          transform="translate(0.125 0.125)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TotalSentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <circle cx="8.5" cy="8.5" r="8.5" fill="black" />
    <g clipPath="url(#clip0_13758_5666)">
      <path
        d="M5.55841 12.3502L13.5563 8.9219C13.9276 8.76148 13.9276 8.23898 13.5563 8.07856L5.55841 4.65023C5.25591 4.51731 4.92133 4.7419 4.92133 5.06731L4.91675 7.18023C4.91675 7.4094 5.08633 7.60648 5.3155 7.63398L11.7917 8.50023L5.3155 9.3619C5.08633 9.39398 4.91675 9.59106 4.91675 9.82023L4.92133 11.9331C4.92133 12.2586 5.25591 12.4831 5.55841 12.3502Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13758_5666">
        <rect width="11" height="11" fill="white" transform="translate(4 3)" />
      </clipPath>
    </defs>
  </svg>
);

export const GreenCheckIcon = ({ color = "#379C00" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 1.875C5.51172 1.875 1.875 5.51172 1.875 10C1.875 14.4883 5.51172 18.125 10 18.125C14.4883 18.125 18.125 14.4883 18.125 10C18.125 5.51172 14.4883 1.875 10 1.875ZM8.74609 12.8789C8.65234 12.9727 8.51953 13.0508 8.40234 13.0508C8.28516 13.0508 8.15234 12.9688 8.05469 12.875L5.86719 10.6875L6.5625 9.99219L8.40625 11.8359L13.2812 6.92578L13.9648 7.63281L8.74609 12.8789Z"
      fill={color}
    />
  </svg>
);

export const RedCrossIcon = ({ color = "#F44336" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 1.25C-1.56125 1.61625 -1.56375 18.3825 10 18.75C21.5612 18.3838 21.5638 1.6175 10 1.25Z"
      fill={color}
    />
    <path
      d="M10.8839 10.0003L13.5357 7.34847C14.1176 6.78347 13.217 5.88285 12.652 6.46472L10.0001 9.1166L7.34823 6.46472C6.78323 5.88285 5.8826 6.78347 6.46448 7.34847L9.11635 10.0003L6.46448 12.6522C5.88323 13.2172 6.78323 14.1185 7.34823 13.536L10.0001 10.8841L12.652 13.536C13.217 14.1185 14.1176 13.2172 13.5357 12.6522L10.8839 10.0003Z"
      fill="#EEEEEE"
    />
  </svg>
);

export const BlueClockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0001 1.66699C8.35191 1.66699 6.74074 2.15573 5.37033 3.07141C3.99992 3.98709 2.93182 5.28858 2.30109 6.8113C1.67036 8.33401 1.50533 10.0096 1.82687 11.6261C2.14842 13.2426 2.94209 14.7274 4.10753 15.8929C5.27297 17.0583 6.75782 17.852 8.37433 18.1735C9.99084 18.4951 11.6664 18.3301 13.1891 17.6993C14.7118 17.0686 16.0133 16.0005 16.929 14.6301C17.8447 13.2597 18.3334 11.6485 18.3334 10.0003C18.3334 8.90598 18.1179 7.82234 17.6991 6.8113C17.2803 5.80025 16.6665 4.88159 15.8926 4.10777C15.1188 3.33395 14.2002 2.72012 13.1891 2.30133C12.1781 1.88254 11.0944 1.66699 10.0001 1.66699ZM10.8334 10.0003C10.8341 10.11 10.813 10.2187 10.7716 10.3202C10.7301 10.4218 10.669 10.5141 10.5918 10.592L8.09175 13.092C7.93233 13.2285 7.72727 13.2999 7.51754 13.2918C7.30781 13.2837 7.10886 13.1967 6.96045 13.0483C6.81204 12.8999 6.72509 12.7009 6.71699 12.4912C6.70889 12.2815 6.78023 12.0764 6.91675 11.917L9.16675 9.65866V5.83366C9.16675 5.61265 9.25455 5.40068 9.41083 5.2444C9.56711 5.08812 9.77907 5.00033 10.0001 5.00033C10.2211 5.00033 10.4331 5.08812 10.5893 5.2444C10.7456 5.40068 10.8334 5.61265 10.8334 5.83366V10.0003Z"
      fill="#3474F1"
    />
  </svg>
);

export const FemaleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-gender-female"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5"
    />
  </svg>
);

export const MaleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-gender-male"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
    />
  </svg>
);

export const GenderIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M5.23379 7.72989C6.65303 5.48625 9.15342 4 12.0002 4C14.847 4 17.3474 5.48625 18.7667 7.72989L20.4569 6.66071C18.6865 3.86199 15.5612 2 12.0002 2C8.43928 2 5.31393 3.86199 3.54356 6.66071L5.23379 7.72989ZM12.0002 20C9.15342 20 6.65303 18.5138 5.23379 16.2701L3.54356 17.3393C5.31393 20.138 8.43928 22 12.0002 22C15.5612 22 18.6865 20.138 20.4569 17.3393L18.7667 16.2701C17.3474 18.5138 14.847 20 12.0002 20ZM12 8C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12ZM12 15C10.8954 15 10 15.8954 10 17H8C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17H14C14 15.8954 13.1046 15 12 15ZM3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11ZM0 12C0 10.3431 1.34315 9 3 9C4.65685 9 6 10.3431 6 12C6 13.6569 4.65685 15 3 15C1.34315 15 0 13.6569 0 12ZM20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12ZM21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9Z" />
  </svg>
);

export const SendCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-send-check-fill"
    viewBox="0 0 16 16"
    style={{ color: "#CD6300" }}
  >
    <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 1.59 2.498C8 14 8 13 8 12.5a4.5 4.5 0 0 1 5.026-4.47zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z" />
    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686" />
  </svg>
);

export const SendIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M1.94607 9.31543C1.42353 9.14125 1.4194 8.86022 1.95682 8.68108L21.043 2.31901C21.5715 2.14285 21.8746 2.43866 21.7265 2.95694L16.2733 22.0432C16.1223 22.5716 15.8177 22.59 15.5944 22.0876L11.9999 14L17.9999 6.00005L9.99992 12L1.94607 9.31543Z" />
  </svg>
);

export const WhiteBgCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-check"
    viewBox="0 0 16 16"
  >
    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
  </svg>
);

export const WhiteBgXIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-x"
    viewBox="0 0 16 16"
  >
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
  </svg>
);

export const DatePickerIcon = ({ color = "#898989" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_13711_4583)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7494 5.25113V6.00038C12.7396 6.47963 12.2124 6.86888 11.7519 6.70688C11.4616 6.60488 11.2576 6.31088 11.2509 6.00038V5.25113H9.00386C8.42036 5.22338 8.03861 4.47263 8.43761 4.01138C8.54711 3.88538 8.69786 3.79838 8.86211 3.76688C8.92436 3.75488 8.94086 3.75638 9.00386 3.75338H11.2509V3.00413C11.2539 2.88188 11.2651 2.84213 11.2884 2.77013C11.3881 2.46863 11.6949 2.25488 12.0151 2.25488C12.4119 2.27063 12.7404 2.56988 12.7494 3.00413V3.75338H17.2434V3.00413C17.2464 2.88188 17.2576 2.84213 17.2809 2.77013C17.3806 2.46863 17.6874 2.25488 18.0076 2.25488C18.4044 2.27063 18.7329 2.56988 18.7419 3.00413V3.75338H19.4934C19.5196 3.75338 19.5196 3.75338 19.5466 3.75413C20.6941 3.78938 21.7156 4.77713 21.7381 5.97263C21.7651 10.4771 21.7381 14.9816 21.7381 19.4854C21.7306 20.6471 20.7444 21.7076 19.5189 21.7301C14.5149 21.7609 9.51086 21.7309 4.50761 21.7309C3.33911 21.7234 2.28536 20.7191 2.26286 19.5116C2.23436 15.0071 2.26211 10.5026 2.26211 5.99813C2.26961 4.82663 3.28361 3.76088 4.50761 3.75338H5.25836V3.00413C5.26136 2.88188 5.27261 2.84213 5.29586 2.77013C5.39561 2.46863 5.70236 2.25488 6.02261 2.25488C6.14411 2.26013 6.18461 2.27213 6.25586 2.29763C6.54611 2.39963 6.75086 2.69363 6.75686 3.00413V6.00038C6.74711 6.47963 6.21986 6.86888 5.75936 6.70688C5.46911 6.60488 5.26511 6.31088 5.25836 6.00038V5.25038C5.00561 5.24963 4.75286 5.24963 4.50011 5.25113C4.11311 5.25863 3.76811 5.59988 3.76061 5.99138C3.73286 10.4914 3.73286 14.9921 3.76061 19.4929C3.76811 19.8806 4.10861 20.2249 4.50011 20.2324C9.50036 20.2631 14.5006 20.2631 19.5001 20.2324C19.8879 20.2249 20.2321 19.8844 20.2396 19.4929C20.2674 14.9921 20.2674 10.4914 20.2396 5.99063C20.2329 5.60213 19.8969 5.25413 19.4881 5.25113H18.7419V6.00038C18.7306 6.55163 18.0061 6.95663 17.5359 6.59363C17.3544 6.45413 17.2479 6.23138 17.2434 6.00038V5.25113H12.7494ZM6.00761 17.2361C6.42086 17.2361 6.75686 17.5721 6.75686 17.9854C6.75686 18.3986 6.42086 18.7346 6.00761 18.7346C5.59436 18.7346 5.25836 18.3986 5.25836 17.9854C5.25836 17.5721 5.59436 17.2361 6.00761 17.2361ZM9.00386 17.2361C9.41711 17.2361 9.75311 17.5721 9.75311 17.9854C9.75311 18.3986 9.41711 18.7346 9.00386 18.7346C8.59061 18.7346 8.25461 18.3986 8.25461 17.9854C8.25461 17.5721 8.59061 17.2361 9.00386 17.2361ZM12.0001 17.2361C12.4134 17.2361 12.7494 17.5721 12.7494 17.9854C12.7494 18.3986 12.4134 18.7346 12.0001 18.7346C11.5869 18.7346 11.2509 18.3986 11.2509 17.9854C11.2509 17.5721 11.5869 17.2361 12.0001 17.2361ZM6.00761 14.2399C6.42086 14.2399 6.75686 14.5759 6.75686 14.9891C6.75686 15.4024 6.42086 15.7384 6.00761 15.7384C5.59436 15.7384 5.25836 15.4024 5.25836 14.9891C5.25836 14.5759 5.59436 14.2399 6.00761 14.2399ZM9.00386 14.2399C9.41711 14.2399 9.75311 14.5759 9.75311 14.9891C9.75311 15.4024 9.41711 15.7384 9.00386 15.7384C8.59061 15.7384 8.25461 15.4024 8.25461 14.9891C8.25461 14.5759 8.59061 14.2399 9.00386 14.2399ZM12.0001 14.2399C12.4134 14.2399 12.7494 14.5759 12.7494 14.9891C12.7494 15.4024 12.4134 15.7384 12.0001 15.7384C11.5869 15.7384 11.2509 15.4024 11.2509 14.9891C11.2509 14.5759 11.5869 14.2399 12.0001 14.2399ZM14.9964 14.2399C15.4096 14.2399 15.7456 14.5759 15.7456 14.9891C15.7456 15.4024 15.4096 15.7384 14.9964 15.7384C14.5831 15.7384 14.2471 15.4024 14.2471 14.9891C14.2471 14.5759 14.5831 14.2399 14.9964 14.2399ZM17.9926 14.2399C18.4059 14.2399 18.7419 14.5759 18.7419 14.9891C18.7419 15.4024 18.4059 15.7384 17.9926 15.7384C17.5794 15.7384 17.2434 15.4024 17.2434 14.9891C17.2434 14.5759 17.5794 14.2399 17.9926 14.2399ZM9.00386 11.2436C9.41711 11.2436 9.75311 11.5796 9.75311 11.9929C9.75311 12.4061 9.41711 12.7421 9.00386 12.7421C8.59061 12.7421 8.25461 12.4061 8.25461 11.9929C8.25461 11.5796 8.59061 11.2436 9.00386 11.2436ZM12.0001 11.2436C12.4134 11.2436 12.7494 11.5796 12.7494 11.9929C12.7494 12.4061 12.4134 12.7421 12.0001 12.7421C11.5869 12.7421 11.2509 12.4061 11.2509 11.9929C11.2509 11.5796 11.5869 11.2436 12.0001 11.2436ZM14.9964 11.2436C15.4096 11.2436 15.7456 11.5796 15.7456 11.9929C15.7456 12.4061 15.4096 12.7421 14.9964 12.7421C14.5831 12.7421 14.2471 12.4061 14.2471 11.9929C14.2471 11.5796 14.5831 11.2436 14.9964 11.2436ZM17.9926 11.2436C18.4059 11.2436 18.7419 11.5796 18.7419 11.9929C18.7419 12.4061 18.4059 12.7421 17.9926 12.7421C17.5794 12.7421 17.2434 12.4061 17.2434 11.9929C17.2434 11.5796 17.5794 11.2436 17.9926 11.2436Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_13711_4583">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BuildingIcon = ({ color = "#000" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
    <path d="M10 6h4" />
    <path d="M10 10h4" />
    <path d="M10 14h4" />
    <path d="M10 18h4" />
  </svg>
);

export const BuildingIcon1 = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M21 20H23V22H1V20H3V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V20ZM19 20V4H5V20H19ZM8 11H11V13H8V11ZM8 7H11V9H8V7ZM8 15H11V17H8V15ZM13 15H16V17H13V15ZM13 11H16V13H13V11ZM13 7H16V9H13V7Z" />
  </svg>
);

export const AlertIcon = ({ color = "#000" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <path d="M12 9v4" />
    <path d="m12 17 .01 0" />
  </svg>
);

export const FileIcon = ({ color = "#000" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    <path d="M10 9H8" />
    <path d="M16 13H8" />
    <path d="M16 17H8" />
  </svg>
);

export const FileIcon2 = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM6 15V17H18V15H6ZM6 7V13H12V7H6ZM14 7V9H18V7H14ZM14 11V13H18V11H14ZM8 9H10V11H8V9Z" />
  </svg>
);

export const ArrowGrowIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill={color}
    viewBox="0 0 24 24"
  >
    <path d="M3 17l6-6 4 4 8-8v5h2V7a1 1 0 0 0-1-1h-5v2h4l-7 7-4-4-7 7z" />
  </svg>
);

export const RightTickIcon = ({ color = "#000" }) => (
  <svg
    className="pp-employee-payroll-action-button-icon"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path d="M5 13l4 4L19 7" />
  </svg>
);

export const ReviewIcon = ({ color = "#000" }) => (
  <svg
    className="pp-employee-payroll-action-button-icon"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

export const ResolveIcon = () => (
  <svg
    className="pp-discrepancy-action-icon"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

export const ProcessingFlowIcon = ({ color = "#000" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="8" height="8" x="3" y="3" rx="2" />
    <path d="m7 11 0 4" />
    <rect width="8" height="8" x="13" y="13" rx="2" />
    <path d="m17 11 0 2" />
    <path d="m7 7 4 0" />
    <path d="m11 7 6 0" />
    <path d="m17 7 0 4" />
  </svg>
);

export const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
      fill="url(#paint0_linear_14023_4477)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_14023_4477"
        x1="3.62891"
        y1="11.6344"
        x2="21.1881"
        y2="11.6344"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0447915" stopColor="#B4000B" />
        <stop offset="1" stopColor="#DD0000" />
      </linearGradient>
    </defs>
  </svg>
);

export const BinIcon = ({ color = "#B4000B" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="currentColor"
  >
    <path
      d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
      fill={color}
    />
  </svg>
);

export const DateRangerIcon = ({ color = "#898989" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_13711_4583)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7494 5.25113V6.00038C12.7396 6.47963 12.2124 6.86888 11.7519 6.70688C11.4616 6.60488 11.2576 6.31088 11.2509 6.00038V5.25113H9.00386C8.42036 5.22338 8.03861 4.47263 8.43761 4.01138C8.54711 3.88538 8.69786 3.79838 8.86211 3.76688C8.92436 3.75488 8.94086 3.75638 9.00386 3.75338H11.2509V3.00413C11.2539 2.88188 11.2651 2.84213 11.2884 2.77013C11.3881 2.46863 11.6949 2.25488 12.0151 2.25488C12.4119 2.27063 12.7404 2.56988 12.7494 3.00413V3.75338H17.2434V3.00413C17.2464 2.88188 17.2576 2.84213 17.2809 2.77013C17.3806 2.46863 17.6874 2.25488 18.0076 2.25488C18.4044 2.27063 18.7329 2.56988 18.7419 3.00413V3.75338H19.4934C19.5196 3.75338 19.5196 3.75338 19.5466 3.75413C20.6941 3.78938 21.7156 4.77713 21.7381 5.97263C21.7651 10.4771 21.7381 14.9816 21.7381 19.4854C21.7306 20.6471 20.7444 21.7076 19.5189 21.7301C14.5149 21.7609 9.51086 21.7309 4.50761 21.7309C3.33911 21.7234 2.28536 20.7191 2.26286 19.5116C2.23436 15.0071 2.26211 10.5026 2.26211 5.99813C2.26961 4.82663 3.28361 3.76088 4.50761 3.75338H5.25836V3.00413C5.26136 2.88188 5.27261 2.84213 5.29586 2.77013C5.39561 2.46863 5.70236 2.25488 6.02261 2.25488C6.14411 2.26013 6.18461 2.27213 6.25586 2.29763C6.54611 2.39963 6.75086 2.69363 6.75686 3.00413V6.00038C6.74711 6.47963 6.21986 6.86888 5.75936 6.70688C5.46911 6.60488 5.26511 6.31088 5.25836 6.00038V5.25038C5.00561 5.24963 4.75286 5.24963 4.50011 5.25113C4.11311 5.25863 3.76811 5.59988 3.76061 5.99138C3.73286 10.4914 3.73286 14.9921 3.76061 19.4929C3.76811 19.8806 4.10861 20.2249 4.50011 20.2324C9.50036 20.2631 14.5006 20.2631 19.5001 20.2324C19.8879 20.2249 20.2321 19.8844 20.2396 19.4929C20.2674 14.9921 20.2674 10.4914 20.2396 5.99063C20.2329 5.60213 19.8969 5.25413 19.4881 5.25113H18.7419V6.00038C18.7306 6.55163 18.0061 6.95663 17.5359 6.59363C17.3544 6.45413 17.2479 6.23138 17.2434 6.00038V5.25113H12.7494ZM6.00761 17.2361C6.42086 17.2361 6.75686 17.5721 6.75686 17.9854C6.75686 18.3986 6.42086 18.7346 6.00761 18.7346C5.59436 18.7346 5.25836 18.3986 5.25836 17.9854C5.25836 17.5721 5.59436 17.2361 6.00761 17.2361ZM9.00386 17.2361C9.41711 17.2361 9.75311 17.5721 9.75311 17.9854C9.75311 18.3986 9.41711 18.7346 9.00386 18.7346C8.59061 18.7346 8.25461 18.3986 8.25461 17.9854C8.25461 17.5721 8.59061 17.2361 9.00386 17.2361ZM12.0001 17.2361C12.4134 17.2361 12.7494 17.5721 12.7494 17.9854C12.7494 18.3986 12.4134 18.7346 12.0001 18.7346C11.5869 18.7346 11.2509 18.3986 11.2509 17.9854C11.2509 17.5721 11.5869 17.2361 12.0001 17.2361ZM6.00761 14.2399C6.42086 14.2399 6.75686 14.5759 6.75686 14.9891C6.75686 15.4024 6.42086 15.7384 6.00761 15.7384C5.59436 15.7384 5.25836 15.4024 5.25836 14.9891C5.25836 14.5759 5.59436 14.2399 6.00761 14.2399ZM9.00386 14.2399C9.41711 14.2399 9.75311 14.5759 9.75311 14.9891C9.75311 15.4024 9.41711 15.7384 9.00386 15.7384C8.59061 15.7384 8.25461 15.4024 8.25461 14.9891C8.25461 14.5759 8.59061 14.2399 9.00386 14.2399ZM12.0001 14.2399C12.4134 14.2399 12.7494 14.5759 12.7494 14.9891C12.7494 15.4024 12.4134 15.7384 12.0001 15.7384C11.5869 15.7384 11.2509 15.4024 11.2509 14.9891C11.2509 14.5759 11.5869 14.2399 12.0001 14.2399ZM14.9964 14.2399C15.4096 14.2399 15.7456 14.5759 15.7456 14.9891C15.7456 15.4024 15.4096 15.7384 14.9964 15.7384C14.5831 15.7384 14.2471 15.4024 14.2471 14.9891C14.2471 14.5759 14.5831 14.2399 14.9964 14.2399ZM17.9926 14.2399C18.4059 14.2399 18.7419 14.5759 18.7419 14.9891C18.7419 15.4024 18.4059 15.7384 17.9926 15.7384C17.5794 15.7384 17.2434 15.4024 17.2434 14.9891C17.2434 14.5759 17.5794 14.2399 17.9926 14.2399ZM9.00386 11.2436C9.41711 11.2436 9.75311 11.5796 9.75311 11.9929C9.75311 12.4061 9.41711 12.7421 9.00386 12.7421C8.59061 12.7421 8.25461 12.4061 8.25461 11.9929C8.25461 11.5796 8.59061 11.2436 9.00386 11.2436ZM12.0001 11.2436C12.4134 11.2436 12.7494 11.5796 12.7494 11.9929C12.7494 12.4061 12.4134 12.7421 12.0001 12.7421C11.5869 12.7421 11.2509 12.4061 11.2509 11.9929C11.2509 11.5796 11.5869 11.2436 12.0001 11.2436ZM14.9964 11.2436C15.4096 11.2436 15.7456 11.5796 15.7456 11.9929C15.7456 12.4061 15.4096 12.7421 14.9964 12.7421C14.5831 12.7421 14.2471 12.4061 14.2471 11.9929C14.2471 11.5796 14.5831 11.2436 14.9964 11.2436ZM17.9926 11.2436C18.4059 11.2436 18.7419 11.5796 18.7419 11.9929C18.7419 12.4061 18.4059 12.7421 17.9926 12.7421C17.5794 12.7421 17.2434 12.4061 17.2434 11.9929C17.2434 11.5796 17.5794 11.2436 17.9926 11.2436Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_13711_4583">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DateRangerIcon1 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_13711_4583)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7494 5.25113V6.00038C12.7396 6.47963 12.2124 6.86888 11.7519 6.70688C11.4616 6.60488 11.2576 6.31088 11.2509 6.00038V5.25113H9.00386C8.42036 5.22338 8.03861 4.47263 8.43761 4.01138C8.54711 3.88538 8.69786 3.79838 8.86211 3.76688C8.92436 3.75488 8.94086 3.75638 9.00386 3.75338H11.2509V3.00413C11.2539 2.88188 11.2651 2.84213 11.2884 2.77013C11.3881 2.46863 11.6949 2.25488 12.0151 2.25488C12.4119 2.27063 12.7404 2.56988 12.7494 3.00413V3.75338H17.2434V3.00413C17.2464 2.88188 17.2576 2.84213 17.2809 2.77013C17.3806 2.46863 17.6874 2.25488 18.0076 2.25488C18.4044 2.27063 18.7329 2.56988 18.7419 3.00413V3.75338H19.4934C19.5196 3.75338 19.5196 3.75338 19.5466 3.75413C20.6941 3.78938 21.7156 4.77713 21.7381 5.97263C21.7651 10.4771 21.7381 14.9816 21.7381 19.4854C21.7306 20.6471 20.7444 21.7076 19.5189 21.7301C14.5149 21.7609 9.51086 21.7309 4.50761 21.7309C3.33911 21.7234 2.28536 20.7191 2.26286 19.5116C2.23436 15.0071 2.26211 10.5026 2.26211 5.99813C2.26961 4.82663 3.28361 3.76088 4.50761 3.75338H5.25836V3.00413C5.26136 2.88188 5.27261 2.84213 5.29586 2.77013C5.39561 2.46863 5.70236 2.25488 6.02261 2.25488C6.14411 2.26013 6.18461 2.27213 6.25586 2.29763C6.54611 2.39963 6.75086 2.69363 6.75686 3.00413V6.00038C6.74711 6.47963 6.21986 6.86888 5.75936 6.70688C5.46911 6.60488 5.26511 6.31088 5.25836 6.00038V5.25038C5.00561 5.24963 4.75286 5.24963 4.50011 5.25113C4.11311 5.25863 3.76811 5.59988 3.76061 5.99138C3.73286 10.4914 3.73286 14.9921 3.76061 19.4929C3.76811 19.8806 4.10861 20.2249 4.50011 20.2324C9.50036 20.2631 14.5006 20.2631 19.5001 20.2324C19.8879 20.2249 20.2321 19.8844 20.2396 19.4929C20.2674 14.9921 20.2674 10.4914 20.2396 5.99063C20.2329 5.60213 19.8969 5.25413 19.4881 5.25113H18.7419V6.00038C18.7306 6.55163 18.0061 6.95663 17.5359 6.59363C17.3544 6.45413 17.2479 6.23138 17.2434 6.00038V5.25113H12.7494ZM6.00761 17.2361C6.42086 17.2361 6.75686 17.5721 6.75686 17.9854C6.75686 18.3986 6.42086 18.7346 6.00761 18.7346C5.59436 18.7346 5.25836 18.3986 5.25836 17.9854C5.25836 17.5721 5.59436 17.2361 6.00761 17.2361ZM9.00386 17.2361C9.41711 17.2361 9.75311 17.5721 9.75311 17.9854C9.75311 18.3986 9.41711 18.7346 9.00386 18.7346C8.59061 18.7346 8.25461 18.3986 8.25461 17.9854C8.25461 17.5721 8.59061 17.2361 9.00386 17.2361ZM12.0001 17.2361C12.4134 17.2361 12.7494 17.5721 12.7494 17.9854C12.7494 18.3986 12.4134 18.7346 12.0001 18.7346C11.5869 18.7346 11.2509 18.3986 11.2509 17.9854C11.2509 17.5721 11.5869 17.2361 12.0001 17.2361ZM6.00761 14.2399C6.42086 14.2399 6.75686 14.5759 6.75686 14.9891C6.75686 15.4024 6.42086 15.7384 6.00761 15.7384C5.59436 15.7384 5.25836 15.4024 5.25836 14.9891C5.25836 14.5759 5.59436 14.2399 6.00761 14.2399ZM9.00386 14.2399C9.41711 14.2399 9.75311 14.5759 9.75311 14.9891C9.75311 15.4024 9.41711 15.7384 9.00386 15.7384C8.59061 15.7384 8.25461 15.4024 8.25461 14.9891C8.25461 14.5759 8.59061 14.2399 9.00386 14.2399ZM12.0001 14.2399C12.4134 14.2399 12.7494 14.5759 12.7494 14.9891C12.7494 15.4024 12.4134 15.7384 12.0001 15.7384C11.5869 15.7384 11.2509 15.4024 11.2509 14.9891C11.2509 14.5759 11.5869 14.2399 12.0001 14.2399ZM14.9964 14.2399C15.4096 14.2399 15.7456 14.5759 15.7456 14.9891C15.7456 15.4024 15.4096 15.7384 14.9964 15.7384C14.5831 15.7384 14.2471 15.4024 14.2471 14.9891C14.2471 14.5759 14.5831 14.2399 14.9964 14.2399ZM17.9926 14.2399C18.4059 14.2399 18.7419 14.5759 18.7419 14.9891C18.7419 15.4024 18.4059 15.7384 17.9926 15.7384C17.5794 15.7384 17.2434 15.4024 17.2434 14.9891C17.2434 14.5759 17.5794 14.2399 17.9926 14.2399ZM9.00386 11.2436C9.41711 11.2436 9.75311 11.5796 9.75311 11.9929C9.75311 12.4061 9.41711 12.7421 9.00386 12.7421C8.59061 12.7421 8.25461 12.4061 8.25461 11.9929C8.25461 11.5796 8.59061 11.2436 9.00386 11.2436ZM12.0001 11.2436C12.4134 11.2436 12.7494 11.5796 12.7494 11.9929C12.7494 12.4061 12.4134 12.7421 12.0001 12.7421C11.5869 12.7421 11.2509 12.4061 11.2509 11.9929C11.2509 11.5796 11.5869 11.2436 12.0001 11.2436ZM14.9964 11.2436C15.4096 11.2436 15.7456 11.5796 15.7456 11.9929C15.7456 12.4061 15.4096 12.7421 14.9964 12.7421C14.5831 12.7421 14.2471 12.4061 14.2471 11.9929C14.2471 11.5796 14.5831 11.2436 14.9964 11.2436ZM17.9926 11.2436C18.4059 11.2436 18.7419 11.5796 18.7419 11.9929C18.7419 12.4061 18.4059 12.7421 17.9926 12.7421C17.5794 12.7421 17.2434 12.4061 17.2434 11.9929C17.2434 11.5796 17.5794 11.2436 17.9926 11.2436Z"
        fill="#898989"
      />
    </g>
    <defs>
      <clipPath id="clip0_13711_4583">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AttendanceCalendarIcon = () => (
  <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
    <rect
      x="3"
      y="5"
      width="18"
      height="16"
      rx="2"
      fill="#3b82f6"
      fillOpacity="0.08"
    />
    <rect
      x="3"
      y="5"
      width="18"
      height="16"
      rx="2"
      stroke="#3b82f6"
      strokeWidth="1.5"
    />
    <rect x="7" y="2" width="2" height="4" rx="1" fill="#3b82f6" />
    <rect x="15" y="2" width="2" height="4" rx="1" fill="#3b82f6" />
  </svg>
);

export const XIcon = ({ color = "#222" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const PeopleIcon = ({ color = "currentColor", size = 24 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    className="bi bi-people"
    viewBox="0 0 16 16"
  >
    <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
  </svg>
);

export const BiPeopleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-people-fill card-svg"
    viewBox="0 0 16 16"
  >
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
  </svg>
);

export const People3Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    className="aaaga-svg"
  >
    <path
      d="M11.6793 23.1453C11.5233 23.4768 11.4453 23.8473 11.4453 24.2373V26.7658C11.4453 27.1233 11.7378 27.4158 12.0953 27.4158H14.5154V24.8102C14.5154 24.4512 14.8061 24.1602 15.1654 24.1602C15.5246 24.1602 15.8154 24.4512 15.8154 24.8102V27.4158H23.1831V24.8102C23.1831 24.4512 23.4738 24.1602 23.8331 24.1602C24.1924 24.1602 24.4831 24.4512 24.4831 24.8102V27.4158H26.9023C27.2598 27.4158 27.5523 27.1233 27.5523 26.7658V24.1138C27.5523 23.8278 27.5133 23.5613 27.4288 23.3078C26.8893 21.6893 24.8548 20.6038 21.5528 20.1683C21.3838 20.1423 21.2018 20.1943 21.0588 20.3048C20.0188 21.1303 19.0893 21.1758 18.0558 20.4283C18.0298 20.3958 18.0038 20.3633 17.9713 20.3308C17.8413 20.2138 17.6658 20.1488 17.4838 20.1618C14.4873 20.3958 12.4788 21.4293 11.6793 23.1453Z"
      fill="#F56131"
    />
    <path
      d="M19.5018 19.0739C21.5717 19.0739 23.2497 17.3959 23.2497 15.326C23.2497 13.2561 21.5717 11.5781 19.5018 11.5781C17.4319 11.5781 15.7539 13.2561 15.7539 15.326C15.7539 17.3959 17.4319 19.0739 19.5018 19.0739Z"
      fill="#F56131"
    />
    <path
      d="M35.6533 24.1905C35.2308 22.9295 33.7423 22.117 31.2268 21.7855C31.0513 21.7595 30.8758 21.8115 30.7393 21.922C30.0503 22.468 29.4588 22.5005 28.7763 22.0195C28.7633 21.9935 28.7373 21.974 28.7178 21.9545C28.5878 21.831 28.4058 21.766 28.2238 21.779C28.1783 21.7855 28.1328 21.7855 28.0938 21.792C28.3668 22.169 28.5488 22.546 28.6658 22.897C28.7893 23.2805 28.8543 23.677 28.8543 24.1125V26.7645C28.8543 26.992 28.8153 27.213 28.7373 27.421H32.2148V25.341C32.2148 24.9835 32.5073 24.691 32.8648 24.691C33.2223 24.691 33.5148 24.9835 33.5148 25.341V27.421H35.1008C35.4583 27.421 35.7508 27.1285 35.7508 26.771V24.834C35.7508 24.6065 35.7183 24.392 35.6533 24.197C35.6533 24.197 35.6533 24.197 35.6533 24.1905Z"
      fill="#F56131"
    />
    <path
      d="M32.0998 20.2572C33.4197 18.9372 33.4197 16.7971 32.0998 15.4772C30.7798 14.1572 28.6397 14.1572 27.3197 15.4772C25.9997 16.7971 25.9997 18.9372 27.3197 20.2572C28.6397 21.5772 30.7798 21.5772 32.0998 20.2572Z"
      fill="#F56131"
    />
    <path
      d="M3.34752 24.1973C3.28249 24.3988 3.25 24.6068 3.25 24.8343V26.7713C3.25 27.1288 3.54251 27.4213 3.9 27.4213H5.486V25.3413C5.486 24.9838 5.77851 24.6913 6.136 24.6913C6.49349 24.6913 6.786 24.9838 6.786 25.3413V27.4213H10.2635C10.1855 27.2133 10.1465 26.9923 10.1465 26.7648V24.2363C10.1465 23.6448 10.27 23.0923 10.504 22.5918C10.621 22.3383 10.7705 22.0718 10.9655 21.7988C10.907 21.7923 10.842 21.7858 10.777 21.7793C10.595 21.7663 10.413 21.8443 10.283 21.9678C10.27 21.9743 10.2635 21.9873 10.2505 21.9938C9.56151 22.5008 8.95702 22.4748 8.26151 21.9223C8.125 21.8118 7.94949 21.7598 7.77401 21.7858C5.25852 22.1173 3.76999 22.9298 3.34752 24.1973ZM9.29499 14.4863C7.42949 14.4863 5.91498 16.0008 5.91498 17.8663C5.91498 19.7318 7.42949 21.2463 9.29499 21.2463C11.154 21.2463 12.6685 19.7318 12.6685 17.8663C12.6685 16.0008 11.154 14.4863 9.29499 14.4863Z"
      fill="#F56131"
    />
  </svg>
);

export const PersonExclamationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-person-exclamation aaaga-svg"
    viewBox="0 0 16 16"
    style={{ color: "#5C527F" }}
  >
    <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.256 7a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5m0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
  </svg>
);

export const FolderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-grid-fill"
    viewBox="0 0 16 16"
  >
    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z" />
  </svg>
);

export const LeftArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-caret-left-fill"
    viewBox="0 0 16 16"
  >
    <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" />
  </svg>
);

export const RightArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-caret-right-fill"
    viewBox="0 0 16 16"
  >
    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 3v18h18" />
    <path d="m19 9-5 5-4-4-3 3" />
  </svg>
);

export const PipelineIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="22,7 13.5,15.5 8.5,10.5 2,17" />
    <polyline points="16,7 22,7 22,13" />
  </svg>
);

export const LeadManagementIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="m22 21-3-3" />
    <path d="M16 8a4 4 0 0 1 0 8" />
  </svg>
);

export const AgentManagementIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <polyline points="16,11 18,13 22,9" />
  </svg>
);

export const AnalyticsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m22 12-4-4-6 6-4-4-4 4" />
  </svg>
);

export const ClosureIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

export const SalesPipelineIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const TrendingUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="22,7 13.5,15.5 8.5,10.5 2,17" />
    <polyline points="16,7 22,7 22,13" />
  </svg>
);

export const TrendingDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="22,17 13.5,8.5 8.5,13.5 2,7" />
    <polyline points="16,17 22,17 22,11" />
  </svg>
);

export const Users = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="m22 21-3-3" />
    <path d="M16 8a4 4 0 0 1 0 8" />
  </svg>
);

export const Target = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2" />
  </svg>
);

export const Target1 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-bullseye card-svg"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="M8 13A5 5 0 1 1 8 3a5 5 0 0 1 0 10m0 1A6 6 0 1 0 8 2a6 6 0 0 0 0 12" />
    <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8" />
    <path d="M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
  </svg>
);

export const Activity = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="22,12 18,12 15,21 9,3 6,12 2,12" />
  </svg>
);

export const AlertTriangle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <path d="M12 9v4" />
    <path d="m12 17 .01 0" />
  </svg>
);

export const FilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46" />
  </svg>
);

export const ClosedWonArrow = ({ color = "#22c55e" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 17l10-10" />
    <path d="M7 7h10v10" />
  </svg>
);

export const MovedOutArrow = ({ color = "#ef4444" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 7l10 10" />
    <path d="M17 7v10H7" />
  </svg>
);

export const NewEntriesArrow = ({ color = "#3b82f6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

export const Plus = ({ color = "#6b7280" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </svg>
);

export const Minus = ({ color = "#6b7280" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14" />
  </svg>
);

export const Maximize2 = ({ color = "#6b7280" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15,3 21,3 21,9" />
    <polyline points="9,21 3,21 3,15" />
    <line x1="21" y1="3" x2="14" y2="10" />
    <line x1="3" y1="21" x2="10" y2="14" />
  </svg>
);

export const Lock = ({ color = "#6b7280" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
    <circle cx="12" cy="16" r="1" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-search"
    viewBox="0 0 16 16"
  >
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
  </svg>
);

export const PIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-file-ppt-fill card-svg"
    viewBox="0 0 16 16"
  >
    <path d="M8.188 8.5H7V5h1.188a1.75 1.75 0 1 1 0 3.5" />
    <path d="M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m3 4a1 1 0 0 0-1 1v6.5a.5.5 0 0 0 1 0v-2h1.188a2.75 2.75 0 0 0 0-5.5z" />
  </svg>
);

export const GraphUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-graph-up card-svg"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"
    />
  </svg>
);

export const TrendingUpIcon2 = ({ color = "currentColor" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
  >
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
    <polyline points="17 6 23 6 23 12"></polyline>
  </svg>
);

export const SlashCircleIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-slash-circle"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="M11.354 4.646a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 .708.708l6-6a.5.5 0 0 0 0-.708" />
  </svg>
);

export const InfoCircleIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-info-circle"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
  </svg>
);

export const ArrowClockwiseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-arrow-clockwise"
    viewBox="0 0 16 16"
    style={{
      color: "#fff",
      fill: "#fff",
    }}
  >
    <path
      fillRule="evenodd"
      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
    />
    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
  </svg>
);

export const BiCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-check"
    viewBox="0 0 16 16"
  >
    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
  </svg>
);

export const BiXIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-x"
    viewBox="0 0 16 16"
  >
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
  </svg>
);

export const BiSearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-search"
    viewBox="0 0 16 16"
  >
    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
  </svg>
);

export const ReceptionistIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g clipPath="url(#clip0_18194_6249)">
      <path
        d="M8.1905 6.26968C9.46501 6.26968 10.4982 5.23649 10.4982 3.96199C10.4982 2.68749 9.46501 1.6543 8.1905 1.6543C6.916 1.6543 5.88281 2.68749 5.88281 3.96199C5.88281 5.23649 6.916 6.26968 8.1905 6.26968Z"
        stroke="#0C0B0B"
        strokeWidth="1.53846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1914 11.6547V10.5778C13.1914 9.88552 12.8068 9.19321 12.1145 8.88552C10.9606 8.19321 9.57602 7.88552 8.19141 7.80859C6.80679 7.80859 5.42218 8.19321 4.26833 8.88552C3.65294 9.19321 3.19141 9.88552 3.19141 10.5778V11.6547"
        stroke="#0C0B0B"
        strokeWidth="1.53846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.19081 15.4997L3.96004 19.3459M17.8062 15.4997L17.037 19.3459M15.4985 11.6535V11.2689C15.4985 10.6535 16.037 10.1151 16.6523 10.1151M16.6523 10.1151C17.2677 10.1151 17.8062 10.6535 17.8062 11.2689V11.6535M16.6523 10.1151V9.73047M2.80619 11.6535H18.1908C18.8062 11.6535 19.3447 12.192 19.3447 12.8074V14.3459C19.3447 14.9612 18.8062 15.4997 18.1908 15.4997H2.80619C2.19081 15.4997 1.65234 14.9612 1.65234 14.3459V12.8074C1.65234 12.192 2.19081 11.6535 2.80619 11.6535Z"
        stroke="#0C0B0B"
        strokeWidth="1.53846"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_18194_6249">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TrainerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M18.0003 6.92509C17.4692 6.27984 16.8009 5.76105 16.0441 5.40644C15.2873 5.05184 14.461 4.87032 13.6253 4.87509H3.62531C3.12803 4.87509 2.65112 5.07264 2.29949 5.42427C1.94785 5.7759 1.75031 6.25281 1.75031 6.75009V9.46884C1.74228 9.91014 1.8902 10.3401 2.16801 10.6831C2.44582 11.0261 2.83571 11.2601 3.26906 11.3438L7.95031 12.2563C8.05384 12.2766 8.15055 12.3228 8.23142 12.3906C8.31229 12.4583 8.37469 12.5455 8.41281 12.6438C8.83398 13.6788 9.55576 14.5637 10.4849 15.1842C11.4141 15.8048 12.508 16.1325 13.6253 16.1251C13.9691 16.1246 14.3121 16.0932 14.6503 16.0313C15.7491 15.8307 16.7632 15.3074 17.5635 14.5283C18.3638 13.7491 18.914 12.7493 19.1441 11.6563C19.3158 10.8322 19.3023 9.98027 19.1045 9.16202C18.9067 8.34378 18.5296 7.57972 18.0003 6.92509ZM17.9441 11.3876C17.7741 12.2405 17.351 13.0223 16.73 13.631C16.109 14.2398 15.3189 14.6472 14.4628 14.8001C13.4703 14.9866 12.4438 14.824 11.5575 14.3398C10.6712 13.8557 9.97969 13.0798 9.60031 12.1438C9.48115 11.8491 9.289 11.5895 9.04191 11.3894C8.79482 11.1893 8.50091 11.0553 8.18781 11.0001L3.50656 10.0813C3.36211 10.0534 3.23215 9.97542 3.13954 9.8611C3.04694 9.74677 2.99763 9.60344 3.00031 9.45634V6.75009C3.00031 6.58433 3.06616 6.42536 3.18337 6.30815C3.30058 6.19094 3.45955 6.12509 3.62531 6.12509H6.75031V7.37509C6.75031 7.54085 6.81616 7.69982 6.93337 7.81703C7.05058 7.93424 7.20955 8.00009 7.37531 8.00009C7.54107 8.00009 7.70004 7.93424 7.81725 7.81703C7.93446 7.69982 8.00031 7.54085 8.00031 7.37509V6.12509H13.6253C14.2706 6.12541 14.9078 6.26847 15.4913 6.544C16.0748 6.81954 16.5901 7.22074 17.0003 7.71884C17.4151 8.22434 17.7122 8.81582 17.87 9.45038C18.0278 10.0849 18.0425 10.7467 17.9128 11.3876H17.9441Z"
      fill="#0C0B0B"
    />
    <path
      d="M13.625 7.375C13.0069 7.375 12.4027 7.55828 11.8888 7.90166C11.3749 8.24504 10.9744 8.7331 10.7379 9.30411C10.5014 9.87513 10.4395 10.5035 10.56 11.1097C10.6806 11.7158 10.9783 12.2727 11.4153 12.7097C11.8523 13.1467 12.4092 13.4444 13.0153 13.565C13.6215 13.6855 14.2499 13.6236 14.8209 13.3871C15.3919 13.1506 15.88 12.7501 16.2233 12.2362C16.5667 11.7223 16.75 11.1181 16.75 10.5C16.75 9.6712 16.4208 8.87634 15.8347 8.29029C15.2487 7.70424 14.4538 7.375 13.625 7.375ZM13.625 12.375C13.2542 12.375 12.8917 12.265 12.5833 12.059C12.275 11.853 12.0346 11.5601 11.8927 11.2175C11.7508 10.8749 11.7137 10.4979 11.786 10.1342C11.8584 9.77049 12.037 9.4364 12.2992 9.17417C12.5614 8.91195 12.8955 8.73337 13.2592 8.66103C13.6229 8.58868 13.9999 8.62581 14.3425 8.76773C14.6851 8.90964 14.978 9.14996 15.184 9.45831C15.39 9.76665 15.5 10.1292 15.5 10.5C15.5 10.9973 15.3025 11.4742 14.9508 11.8258C14.5992 12.1775 14.1223 12.375 13.625 12.375Z"
      fill="#0C0B0B"
    />
  </svg>
);

export const TrainerIcon1 = ({ color = "#1475AB" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    className="aaaga-svg"
  >
    <circle cx="22.5" cy="22.5" r="22.5" fill="#F5F5F5" />
    <g clipPath="url(#clip0_8562_3322)">
      <path
        d="M22.3206 26.1399L22.9509 17.6066C23.5328 18.8672 24.5025 20.1278 26.0055 20.7096C26.5873 20.3702 27.2661 20.2247 27.7994 20.3217C28.0418 19.6914 27.654 19.1096 27.0721 19.0126C24.8903 18.5763 23.8721 15.0369 23.8721 13.9702C23.7267 12.4187 17.4237 9.65504 14.1267 13.3399C14.0297 13.4369 11.7994 16.0066 12.0418 18.8672C12.1873 20.3217 12.9146 21.5823 14.2237 22.649C14.66 22.9884 15.2418 22.8914 15.5812 22.5035C15.9206 22.0672 15.8237 21.4853 15.4358 21.146C14.5631 20.4672 14.0782 19.6429 13.9812 18.7217C13.8843 17.752 14.2237 16.8308 14.6115 16.1035L14.9025 19.8853C15.0964 20.1763 15.3873 20.4672 15.7267 20.7581C16.357 21.2429 16.454 22.1641 15.9691 22.7944C15.7752 23.0853 15.4843 23.2308 15.1934 23.3278L15.3873 26.1884C15.3873 26.2853 15.4843 26.3823 15.5328 26.4308L15.2903 35.0126C15.2903 35.8369 15.9206 36.4672 16.6964 36.5156C17.5206 36.5156 18.1509 35.8853 18.1994 35.1096L18.4418 26.5278V26.4793H19.1691V26.5278L19.46 35.0611C19.46 35.8369 20.1388 36.4672 20.9146 36.4672C21.7388 36.4672 22.3691 35.7884 22.3691 34.9641L22.1267 26.3823C22.2237 26.3338 22.2721 26.2853 22.3206 26.1399Z"
        fill={color}
      />
      <path
        d="M18.8785 11.1086C20.4316 11.1086 21.6906 9.84959 21.6906 8.2965C21.6906 6.7434 20.4316 5.48438 18.8785 5.48438C17.3254 5.48438 16.0664 6.7434 16.0664 8.2965C16.0664 9.84959 17.3254 11.1086 18.8785 11.1086Z"
        fill={color}
      />
      <path
        d="M10.7349 29.2915C9.37734 29.2915 8.21371 30.4066 8.45613 31.7642C8.01977 32.2491 7.77734 32.9279 7.77734 33.6066C7.77734 35.2066 9.08643 36.5157 10.7349 36.5157C12.3834 36.5157 13.6925 35.2066 13.6925 33.6066C13.6925 32.8794 13.4501 32.2491 13.0137 31.7642C13.2561 30.4066 12.0925 29.2915 10.7349 29.2915ZM10.7349 30.746C10.0561 30.746 9.42583 30.9885 8.8925 31.3763C8.94098 30.5036 9.71674 29.8248 10.7349 29.8248C11.7046 29.8248 12.5289 30.5036 12.5773 31.3763C12.044 30.94 11.4137 30.746 10.7349 30.746ZM25.2319 23.2794C24.7955 23.7642 24.5531 24.443 24.5531 25.1218C24.5531 26.7218 25.8622 28.0309 27.5107 28.0309C29.1592 28.0309 30.4683 26.7218 30.4683 25.1218C30.4683 24.3945 30.2258 23.7642 29.7895 23.2794C30.0319 21.9218 28.8683 20.8066 27.5107 20.8066C26.1531 20.8066 24.9895 21.9218 25.2319 23.2794ZM29.3531 22.843C28.8683 22.4551 28.238 22.2127 27.5107 22.2127C26.8319 22.2127 26.2016 22.4551 25.6683 22.843C25.7167 21.9703 26.4925 21.2915 27.5107 21.2915C28.4804 21.2915 29.2561 21.9703 29.3531 22.843ZM37.8864 31.1824H36.9167C36.7228 31.1824 36.5773 31.3279 36.5773 31.5218V33.2188H25.4743V31.5218C25.4743 31.3279 25.3289 31.1824 25.1349 31.1824H24.1652C23.9713 31.1824 23.8258 31.3279 23.8258 31.5218V36.1279C23.8258 36.3218 23.9713 36.4672 24.1652 36.4672H25.1349C25.3289 36.4672 25.4743 36.3218 25.4743 36.1279V34.4309H36.5289V36.1279C36.5289 36.3218 36.6743 36.4672 36.8683 36.4672H37.838C38.0319 36.4672 38.1773 36.3218 38.1773 36.1279V31.5218C38.2743 31.3763 38.0804 31.1824 37.8864 31.1824Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_8562_3322">
        <rect width="32" height="32" fill="white" transform="translate(7 5)" />
      </clipPath>
    </defs>
  </svg>
);

export const BiArrowsFullScreenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-arrows-fullscreen"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
    />
  </svg>
);

export const BiTrash3FillIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-arrows-fullscreen"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"
    />
  </svg>
);

export const LocationIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-geo-alt"
    viewBox="0 0 16 16"
  >
    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
  </svg>
);

export const LocationIcon1 = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path
      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const FlagIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-flag"
    viewBox="0 0 16 16"
  >
    <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12 12 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A20 20 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a20 20 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21 21 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21 21 0 0 0 14 7.655V1.222z" />
  </svg>
);

export const ExportIcon = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-download"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
  </svg>
);

export const RightArrow = ({ color = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-arrow-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
    />
  </svg>
);

export const WalletIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-wallet2"
      viewBox="0 0 16 16"
    >
      <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
    </svg>
  );
};

export const CloudArrowIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-cloud-arrow-down"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
    />
    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
  </svg>
);

export const PersonArmsUpIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-person-arms-up"
    viewBox="0 0 16 16"
  >
    <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
    <path d="m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.5 1.5 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.7.7 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.7.7 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z" />
  </svg>
);

export const PersonStandingIcon = ({ color = "currentColor", size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    className="bi bi-person-standing"
    viewBox="0 0 16 16"
  >
    <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 6.75v8.5a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.75a.75.75 0 0 0 1.5 0v-2.5a.25.25 0 0 1 .5 0" />
  </svg>
);

export const ExcludeIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-exclude"
    viewBox="0 0 16 16"
  >
    <path d="M0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H2a2 2 0 0 1-2-2zm12 2H5a1 1 0 0 0-1 1v7h7a1 1 0 0 0 1-1z" />
  </svg>
);

export const BicepsIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill={color}
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-biceps-flexed-icon lucide-biceps-flexed"
  >
    <path d="M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1" />
    <path d="M15 14a5 5 0 0 0-7.584 2" />
    <path d="M9.964 6.825C8.019 7.977 9.5 13 8 15" />
  </svg>
);

export const FireIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M12 23C16.1421 23 19.5 19.6421 19.5 15.5C19.5 14.6345 19.2697 13.8032 19 13.0296C17.3333 14.6765 16.0667 15.5 15.2 15.5C19.1954 8.5 17 5.5 11 1.5C11.5 6.49951 8.20403 8.77375 6.86179 10.0366C5.40786 11.4045 4.5 13.3462 4.5 15.5C4.5 19.6421 7.85786 23 12 23ZM12.7094 5.23498C15.9511 7.98528 15.9666 10.1223 13.463 14.5086C12.702 15.8419 13.6648 17.5 15.2 17.5C15.8884 17.5 16.5841 17.2992 17.3189 16.9051C16.6979 19.262 14.5519 21 12 21C8.96243 21 6.5 18.5376 6.5 15.5C6.5 13.9608 7.13279 12.5276 8.23225 11.4932C8.35826 11.3747 8.99749 10.8081 9.02477 10.7836C9.44862 10.4021 9.7978 10.0663 10.1429 9.69677C11.3733 8.37932 12.2571 6.91631 12.7094 5.23498Z" />
  </svg>
);

export const WeightIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M14.0004 6C14.0004 7.10457 13.1049 8 12.0004 8C10.8958 8 10.0004 7.10457 10.0004 6C10.0004 4.89543 10.8958 4 12.0004 4C13.1049 4 14.0004 4.89543 14.0004 6ZM15.4652 8C15.8056 7.41165 16.0004 6.72857 16.0004 6C16.0004 3.79086 14.2095 2 12.0004 2C9.79122 2 8.00036 3.79086 8.00036 6C8.00036 6.72857 8.19515 7.41165 8.53549 8H5.06615C4.57888 8 4.16255 8.3512 4.08045 8.8315L2.2001 19.8315C2.0957 20.4423 2.56618 21 3.18581 21H20.8149C21.4345 21 21.905 20.4423 21.8006 19.8315L19.9203 8.8315C19.8382 8.3512 19.4218 8 18.9346 8H15.4652ZM12.0004 10H18.091L19.6295 19H4.37125L5.90971 10H12.0004Z" />
  </svg>
);

export const FlashLightIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M13 9H21L11 24V15H4L13 0V9ZM11 11V7.22063L7.53238 13H13V17.3944L17.263 11H11Z" />
  </svg>
);

export const DropIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M12 3.09723L7.05025 8.04697C4.31658 10.7806 4.31658 15.2128 7.05025 17.9465C9.78392 20.6801 14.2161 20.6801 16.9497 17.9465C19.6834 15.2128 19.6834 10.7806 16.9497 8.04697L12 3.09723ZM12 0.268799L18.364 6.63276C21.8787 10.1475 21.8787 15.846 18.364 19.3607C14.8492 22.8754 9.15076 22.8754 5.63604 19.3607C2.12132 15.846 2.12132 10.1475 5.63604 6.63276L12 0.268799Z" />
  </svg>
);

export const GreenGlobeIcon = ({ color = "#0A701B" }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill={color}>
    <path d="M12,2C12.74,2 13.47,2.1 14.17,2.28C12.61,3.58 11.62,5.54 11.62,7.73C11.62,11.53 14.68,14.6 18.47,14.6C19.38,14.6 20.25,14.43 21.06,14.12C20.68,18.5 16.94,22 12.28,22C7.39,22 3.44,18.05 3.44,13.16C3.44,8.87 6.35,5.27 10.24,4.42V7.73C10.24,10.76 7.59,13.16 4.56,13.16H3.44C3.44,16.85 6.43,19.84 10.12,19.84C13.81,19.84 16.8,16.85 16.8,13.16V12.03C16.8,9 14.15,6.6 11.12,6.6H9.97V4.42C10.61,4.28 11.29,4.19 12,4.19C12.39,4.19 12.77,4.22 13.14,4.27C13.41,3.03 14.27,2 15.38,1.47C14.32,1.16 13.18,1 12,1C6.48,1 2,5.48 2,11C2,16.52 6.48,21 12,21C17.52,21 22,16.52 22,11C22,9.84 21.84,8.7 21.53,7.64C21,8.75 19.97,9.61 18.73,9.88C18.78,10.25 18.81,10.63 18.81,11.02C18.81,15.91 14.86,19.86 9.97,19.86C5.08,19.86 1.13,15.91 1.13,11.02C1.13,6.73 4.04,3.13 7.93,2.28C8.63,2.1 9.36,2 10.1,2H12Z" />
  </svg>
);

export const GoalIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-goal-icon lucide-goal"
  >
    <path d="M12 13V2l8 4-8 4" />
    <path d="M20.561 10.222a9 9 0 1 1-12.55-5.29" />
    <path d="M8.002 9.997a5 5 0 1 0 8.9 2.02" />
  </svg>
);

export const ResultIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-chart-column-increasing-icon lucide-chart-column-increasing"
  >
    <path d="M13 17V9" />
    <path d="M18 17V5" />
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path d="M8 17v-3" />
  </svg>
);

export const TrainerRatingIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M12 14V22H4C4 17.5817 7.58172 14 12 14ZM18 21.5L15.0611 23.0451L15.6224 19.7725L13.2447 17.4549L16.5305 16.9775L18 14L19.4695 16.9775L22.7553 17.4549L20.3776 19.7725L20.9389 23.0451L18 21.5ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z" />
  </svg>
);

export const WorkoutIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M5.5 21C3.01472 21 1 18.9853 1 16.5C1 14.0147 3.01472 12 5.5 12C7.98528 12 10 14.0147 10 16.5C10 18.9853 7.98528 21 5.5 21ZM5.5 18C6.32843 18 7 17.3284 7 16.5C7 15.6716 6.32843 15 5.5 15C4.67157 15 4 15.6716 4 16.5C4 17.3284 4.67157 18 5.5 18ZM18.5 21C16.0147 21 14 18.9853 14 16.5C14 14.0147 16.0147 12 18.5 12C20.9853 12 23 14.0147 23 16.5C23 18.9853 20.9853 21 18.5 21ZM18.5 18C19.3284 18 20 17.3284 20 16.5C20 15.6716 19.3284 15 18.5 15C17.6716 15 17 15.6716 17 16.5C17 17.3284 17.6716 18 18.5 18ZM11.5314 9.79706L13 12V18H11V13L8.28117 10.7343C8.18221 10.6661 8.08802 10.588 8 10.5C7.21895 9.71895 7.21895 8.45262 8 7.67157L10.8284 4.84315C11.6095 4.0621 12.8758 4.0621 13.6569 4.84315L15.0711 6.25736C16.1746 7.36086 17.5548 8.01891 18.9884 8.23151L18.978 10.2474C17.0335 10.0218 15.1485 9.16323 13.6569 7.67157L11.5314 9.79706ZM16 5C14.8954 5 14 4.10457 14 3C14 1.89543 14.8954 1 16 1C17.1046 1 18 1.89543 18 3C18 4.10457 17.1046 5 16 5Z" />
  </svg>
);

export const TeamIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M12 10C14.2091 10 16 8.20914 16 6 16 3.79086 14.2091 2 12 2 9.79086 2 8 3.79086 8 6 8 8.20914 9.79086 10 12 10ZM5.5 13C6.88071 13 8 11.8807 8 10.5 8 9.11929 6.88071 8 5.5 8 4.11929 8 3 9.11929 3 10.5 3 11.8807 4.11929 13 5.5 13ZM21 10.5C21 11.8807 19.8807 13 18.5 13 17.1193 13 16 11.8807 16 10.5 16 9.11929 17.1193 8 18.5 8 19.8807 8 21 9.11929 21 10.5ZM12 11C14.7614 11 17 13.2386 17 16V22H7V16C7 13.2386 9.23858 11 12 11ZM5 15.9999C5 15.307 5.10067 14.6376 5.28818 14.0056L5.11864 14.0204C3.36503 14.2104 2 15.6958 2 17.4999V21.9999H5V15.9999ZM22 21.9999V17.4999C22 15.6378 20.5459 14.1153 18.7118 14.0056 18.8993 14.6376 19 15.307 19 15.9999V21.9999H22Z" />
  </svg>
);

export const ProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <g clipPath="url(#clip0_18424_7062)">
      <path
        d="M27.888 17.3729L27.8846 11.1693H27.8824C27.8824 10.0305 27.5058 9.00386 26.8974 8.26584C26.3136 7.55777 25.5147 7.11918 24.6394 7.11918H8.169C7.29225 7.11918 6.49236 7.55767 5.90806 8.26563C5.29888 9.00377 4.92189 10.0305 4.92189 11.1694V21.9778C4.92189 23.1179 5.29918 24.145 5.90815 24.8835C6.49298 25.5927 7.29328 26.0318 8.169 26.0318H19.7308C19.9258 26.4195 20.1602 26.786 20.4303 27.1256H8.169C6.95305 27.1256 5.85585 26.5329 5.06647 25.5756C4.30187 24.6484 3.82812 23.3755 3.82812 21.9778V11.1693C3.82812 9.77282 4.30148 8.50034 5.0664 7.57349C5.85536 6.61752 6.95203 6.02539 8.169 6.02539H24.6394C25.8551 6.02539 26.9508 6.61761 27.739 7.5737C28.5032 8.5006 28.9762 9.77302 28.9762 11.1693H28.9741L28.9778 17.9752C28.6353 17.739 28.2702 17.5372 27.888 17.3729Z"
        fill="#212121"
      />
      <path
        d="M25.3947 18.502C24.0975 18.502 22.924 19.0267 22.0753 19.8748C21.2274 20.7219 20.7032 21.8939 20.7032 23.1894C20.7032 24.4855 21.2281 25.6584 22.0769 26.5073C22.9258 27.3561 24.0987 27.881 25.3947 27.881C26.6903 27.881 27.8623 27.3567 28.7094 26.5089C29.5575 25.6602 30.0822 24.4867 30.0822 23.1894C30.0822 21.8955 29.5573 20.7236 28.7089 19.8752C27.8606 19.0269 26.6887 18.502 25.3947 18.502ZM21.3062 19.1015C22.3531 18.0554 23.7985 17.4082 25.3947 17.4082C26.9906 17.4082 28.4359 18.0556 29.4823 19.1019C30.5286 20.1482 31.176 21.5936 31.176 23.1894C31.176 24.7857 30.5288 26.2311 29.4827 27.278C28.4351 28.3264 26.9895 28.9748 25.3947 28.9748C23.7968 28.9748 22.3505 28.3274 21.3036 27.2806C20.2567 26.2337 19.6094 24.7874 19.6094 23.1894C19.6094 21.5947 20.2577 20.1491 21.3062 19.1014L21.3062 19.1015Z"
        fill="#212121"
      />
      <path
        d="M25.925 20.2363V22.645H28.3415V23.7387H25.925V26.1404H24.8313V23.7387H22.4375V22.645H24.8313V20.2363H25.925Z"
        fill="#212121"
      />
      <path
        d="M10.1172 8.75C10.9477 8.75 11.6997 9.08667 12.244 9.63102C12.7883 10.1753 13.125 10.9273 13.125 11.7578C13.125 12.5883 12.7883 13.3403 12.244 13.8846C11.6997 14.429 10.9477 14.7656 10.1172 14.7656C9.28667 14.7656 8.53469 14.4289 7.99039 13.8846C7.44608 13.3403 7.10938 12.5883 7.10938 11.7578C7.10938 10.9273 7.44608 10.1753 7.99039 9.63102C8.5347 9.0867 9.28669 8.75 10.1172 8.75ZM11.4707 10.4043C11.1243 10.058 10.6458 9.84378 10.1172 9.84378C9.58858 9.84378 9.11001 10.058 8.76371 10.4043C8.4174 10.7506 8.20316 11.2292 8.20316 11.7578C8.20316 12.2864 8.41738 12.765 8.76371 13.1113C9.11001 13.4576 9.58858 13.6719 10.1172 13.6719C10.6458 13.6719 11.1243 13.4577 11.4707 13.1113C11.817 12.765 12.0312 12.2864 12.0312 11.7578C12.0312 11.2292 11.817 10.7506 11.4707 10.4043Z"
        fill="#212121"
      />
      <path
        d="M7.75879 15.3125H12.4756C12.9555 15.3125 13.3915 15.5085 13.7071 15.8241C14.0228 16.1398 14.2188 16.5757 14.2188 17.0557V19.585C14.2188 20.0649 14.0228 20.5008 13.7071 20.8165C13.3915 21.1322 12.9555 21.3282 12.4756 21.3282H7.75879C7.27887 21.3282 6.84296 21.1322 6.52724 20.8165C6.21159 20.5009 6.01562 20.0649 6.01562 19.585V17.0557C6.01562 16.5757 6.21158 16.1398 6.52724 15.8241C6.84294 15.5085 7.27885 15.3125 7.75879 15.3125ZM12.4756 16.4063H7.75879C7.58076 16.4063 7.41851 16.4795 7.30058 16.5975C7.18264 16.7154 7.10941 16.8776 7.10941 17.0557V19.585C7.10941 19.763 7.18266 19.9253 7.30058 20.0432C7.41853 20.1611 7.58078 20.2344 7.75879 20.2344H12.4756C12.6536 20.2344 12.8158 20.1611 12.9338 20.0432C13.0518 19.9252 13.125 19.763 13.125 19.585V17.0557C13.125 16.8777 13.0518 16.7154 12.9338 16.5975C12.8159 16.4795 12.6536 16.4063 12.4756 16.4063Z"
        fill="#212121"
      />
      <path
        d="M22.9688 12.5782H15.3125V11.4844H22.9688V12.5782Z"
        fill="#212121"
      />
      <path
        d="M22.9688 16.4063H15.3125V15.3125H22.9688V16.4063Z"
        fill="#212121"
      />
      <path
        d="M19.7798 20.2344H15.3125V19.1406H20.4329C20.1804 19.4809 19.962 19.8476 19.7798 20.2344Z"
        fill="#212121"
      />
    </g>
    <defs>
      <clipPath id="clip0_18424_7062">
        <rect width="35" height="35" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ProfileIcon1 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M10.001 10V14H14.0002L14.0012 10H21.0012L21.0002 14L21.001 21H3.00098V10H10.001ZM8.00098 12H5.00098V19H19.001V16L19.0007 12H16.0007L15.9997 16H8.00098V12ZM16.001 3V9H8.00098V3H16.001ZM14.001 5H10.001V7H14.001V5Z" />
  </svg>
);

export const PTIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 35 36"
    fill="none"
  >
    <path
      d="M11.0452 15.7383C8.30438 15.7383 6.07812 17.9591 6.07812 20.7054C6.07812 23.4516 8.29896 25.6724 11.0452 25.6724C13.786 25.6724 16.0123 23.4516 16.0123 20.7054C16.0123 17.9591 13.786 15.7383 11.0452 15.7383ZM11.0452 24.1395C9.14396 24.1395 7.60563 22.6012 7.60563 20.6999C7.60563 18.7987 9.14396 17.2604 11.0452 17.2604C12.9465 17.2604 14.4848 18.7987 14.4848 20.6999C14.4848 22.6012 12.941 24.1395 11.0452 24.1395Z"
      fill={color}
    />
    <path
      d="M29.1396 8.32974L27.2871 4.39724C26.9783 3.85016 26.4529 3.94766 26.2687 4.03433L15.5058 9.10433C15.1917 9.25599 15.0129 9.59724 15.0833 9.94391L15.2404 10.7347L12.4346 12.0564L11.9254 11.4335C11.7033 11.1627 11.3242 11.076 11.01 11.2277L7.38625 12.9339C3.10167 14.9543 1.26 20.0839 3.28042 24.3631C3.535 24.9102 3.85458 25.4139 4.21208 25.8797C3.05833 26.2481 2.21875 27.3314 2.21875 28.6097C2.21875 30.1914 3.5025 31.4752 5.08417 31.4752C6.63875 31.4752 7.90083 30.2402 7.94417 28.6964C8.92458 29.081 9.97542 29.2868 11.0533 29.2868C11.0533 29.2868 13.09 29.2435 14.7096 28.4635C18.9779 26.4106 20.8358 21.3135 18.8154 17.0343C18.6637 16.7147 18.4958 16.406 18.3008 16.1027L28.8687 9.28849C29.1829 9.08808 29.3021 8.67641 29.1396 8.32974ZM5.07333 29.9531C4.33667 29.9531 3.74083 29.3518 3.74083 28.6152C3.74083 27.8785 4.34208 27.2772 5.07875 27.2772C5.81542 27.2772 6.41667 27.8785 6.41667 28.6152C6.41667 29.3518 5.81542 29.9531 5.07333 29.9531ZM16.8004 15.2577C16.1017 15.7127 16.4808 16.2002 16.6108 16.3681C16.9304 16.7797 17.2067 17.2293 17.4288 17.6952C19.0863 21.216 17.5696 25.4247 14.0542 27.0931C12.7054 27.7322 11.0479 27.7702 11.0479 27.7702C8.32333 27.7702 5.81542 26.1777 4.65625 23.7185C2.99875 20.1977 4.51 15.9835 8.03083 14.3206L11.1183 12.8635L11.6275 13.4864C11.8496 13.7572 12.2287 13.8439 12.5429 13.6922L16.4267 11.8614C16.7408 11.7097 16.9196 11.3685 16.8492 11.0218L16.6921 10.231L26.2254 5.73516L27.4658 8.37308L16.8004 15.2577Z"
      fill={color}
    />
    <path
      d="M25.5874 19.8524L26.4466 23.0588L27.3268 21.5342C29.0114 22.5068 29.5881 24.6591 28.6155 26.3437C28.3177 26.8595 27.9094 27.2675 27.4393 27.5653L27.7529 28.7356C28.5106 28.3328 29.1712 27.7284 29.6319 26.9305C30.9287 24.6843 30.1598 21.8147 27.9136 20.5178L28.7938 18.9932L25.5874 19.8524ZM23.806 27.6325C22.1213 26.6598 21.5446 24.5075 22.5172 22.8229C22.815 22.3071 23.2234 21.8991 23.6934 21.6013L23.3798 20.431C22.6222 20.8338 21.9615 21.4382 21.5009 22.2361C20.204 24.4823 20.973 27.352 23.2192 28.6488L22.3389 30.1734L25.5453 29.3143L24.6862 26.1079L23.806 27.6325Z"
      fill={color}
    />
  </svg>
);

export const CashStackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-cash-stack card-svg"
    viewBox="0 0 16 16"
  >
    <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z" />
  </svg>
);

export const FolderCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-folder-check  card-svg"
    viewBox="0 0 16 16"
  >
    <path d="m.5 3 .04.87a2 2 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2m5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19q-.362.002-.683.12L1.5 2.98a1 1 0 0 1 1-.98z" />
    <path d="M15.854 10.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.707 0l-1.5-1.5a.5.5 0 0 1 .707-.708l1.146 1.147 2.646-2.647a.5.5 0 0 1 .708 0" />
  </svg>
);

export const BiTelephoneForwardFillIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-telephone-forward-fill card-svg"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708"
    />
  </svg>
);

export const ScanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-upc-scan dashboard-card-icon"
    viewBox="0 0 16 16"
  >
    <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z" />
  </svg>
);

export const FemaleMaleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    className="aaaga-svg"
  >
    <path
      d="M30.2258 27.8992C28.9758 27.8992 26.2008 27.8992 23.1258 27.8992C23.2508 27.5742 23.3008 27.2242 23.2508 26.8492C23.0758 25.2492 22.9008 23.6242 22.7508 22.2742C22.7258 22.1242 22.7258 21.9992 22.7008 21.8742C22.6258 21.3742 22.4508 20.6242 21.8008 19.9992L21.6008 19.7992L21.3508 19.6742C21.1758 19.5992 20.9758 19.5242 20.8258 19.4742L20.7258 19.4492C20.2508 19.2992 19.7508 19.1492 19.2758 18.9992L19.0508 18.9242C18.6758 18.8242 18.3258 18.7242 17.9758 18.6242C17.9758 18.5742 17.9758 18.5492 18.0008 18.4992C18.0258 18.2742 18.0258 18.0742 18.0008 17.8742C17.9758 17.5492 17.9008 17.2242 17.7758 16.9242C18.1758 16.6492 18.5508 16.3242 18.8758 15.9742C19.3258 15.4992 19.7258 14.9742 20.0508 14.3992C20.4258 13.7242 20.4258 12.9242 20.0258 12.2742L19.9758 12.2492C19.7258 11.8242 19.4758 11.4242 19.2508 10.9992C19.0008 10.5492 18.9008 9.99922 18.8008 9.32422C18.7258 8.97422 18.6758 8.59922 18.5758 8.22422C18.2758 6.97422 17.7758 5.89922 17.0508 5.04922C17.5758 4.57422 18.2508 4.27422 19.0008 4.22422C19.4008 4.14922 19.8008 4.12422 20.1508 4.09922C20.2758 4.09922 20.4258 4.09922 20.5508 4.07422C20.6758 4.07422 20.8258 4.07422 20.9508 4.09922C21.2758 4.12422 21.6758 4.14922 22.1008 4.22422C23.8758 4.34922 25.2508 5.97422 25.3258 7.69922C25.3508 8.24922 25.3258 8.77422 25.3008 9.17422C25.2758 9.37422 25.2508 9.54922 25.2258 9.72422V9.74922C25.2008 9.87422 25.1758 9.99922 25.1508 10.1242H25.1758C25.7008 10.2492 25.9758 10.7992 25.9508 11.2992V11.3242C25.9508 11.4742 25.9508 11.5992 25.9508 11.7242C25.9508 11.8992 25.9008 12.0742 25.8758 12.2242C25.8758 12.2992 25.8508 12.3492 25.8508 12.4242V12.4742C25.7508 13.2242 25.4008 13.7992 24.8258 14.1242C24.7508 14.1492 24.7508 14.1742 24.7508 14.1992C24.5758 14.8742 24.3008 15.5492 23.8758 16.1242C23.8008 16.2242 23.7258 16.3242 23.6508 16.4242C23.3008 16.8492 23.1258 17.3742 23.0758 17.8992C23.0508 18.0992 23.0508 18.2992 23.0758 18.5242C23.1008 18.8242 23.2008 19.0992 23.4258 19.2992C23.4258 19.2992 23.4258 19.2992 23.4508 19.3242C23.7508 19.5492 24.2008 19.5992 24.5508 19.6992C24.9008 19.7992 25.2508 19.8742 25.5758 19.9742C26.3258 20.1742 27.0508 20.3742 27.7758 20.5992C28.3258 20.7492 28.9008 20.9242 29.4258 21.0992H29.4508C29.6008 21.1492 29.7258 21.1992 29.8758 21.2492C30.1258 21.4742 30.2258 21.7992 30.3008 22.2492C30.3258 22.3492 30.3258 22.4492 30.3508 22.5742C30.5258 24.0992 30.6758 25.6492 30.8508 27.1992C30.9008 27.5742 30.6258 27.8992 30.2258 27.8992Z"
      fill="#151515"
    />
    <path
      d="M21.7 27.0506C21.525 25.5256 21.35 23.9756 21.2 22.4506C21.2 22.3256 21.175 22.2256 21.15 22.1256C21.075 21.6756 20.95 21.3756 20.725 21.1256C20.6 21.0756 20.45 21.0256 20.325 20.9756H20.3C19.75 20.8006 19.2 20.6256 18.65 20.4756C17.925 20.2756 17.175 20.0506 16.45 19.8506C16.1 19.7506 15.75 19.6756 15.425 19.5756C15.075 19.4756 14.625 19.4506 14.325 19.2006C14.325 19.2006 14.3 19.2006 14.3 19.1756C14.075 19.0006 14 18.7006 13.95 18.4006C13.925 18.1756 13.925 17.9756 13.95 17.7756C13.975 17.4756 14.05 17.1756 14.175 16.8756C14.75 16.7256 15.275 16.5506 15.8 16.3006C16.55 15.9506 17.2 15.4756 17.75 14.9006C18.1 14.5256 18.425 14.1256 18.675 13.6506C18.775 13.4506 18.775 13.2756 18.675 13.0756C18.4 12.6256 18.15 12.1756 17.9 11.7006C17.375 10.7256 17.35 9.65058 17.075 8.55058C16.8 7.37558 16.275 6.35058 15.45 5.57558C15.1 5.25058 14.7 4.95058 14.225 4.72558C13.175 4.20058 12.075 4.10058 10.9 4.20058C8.97499 4.40058 7.59999 5.30058 6.77499 6.95058C6.69999 7.12558 6.59999 7.30058 6.52499 7.47558C6.14999 8.40058 5.97499 9.40058 5.62499 10.3506C5.24999 11.3006 4.69999 12.1506 4.19999 13.0256C4.07499 13.2756 4.04999 13.4756 4.19999 13.7006C4.54999 14.3006 4.97499 14.8006 5.44999 15.2256C6.02499 15.7256 6.67499 16.1256 7.39999 16.4506C7.82499 16.6256 8.27499 16.7756 8.69999 16.8756C8.82499 17.1506 8.89999 17.4506 8.89999 17.7506C8.92499 17.9506 8.92499 18.1506 8.89999 18.3756C8.87499 18.6756 8.77499 18.9506 8.54999 19.1506C8.54999 19.1506 8.54999 19.1506 8.52499 19.1756C8.22499 19.4006 7.77499 19.4506 7.42499 19.5506C7.07499 19.6506 6.72499 19.7256 6.39999 19.8256C5.67499 20.0256 4.92499 20.2256 4.19999 20.4506C3.64999 20.6256 3.09999 20.7756 2.54999 20.9506H2.52499C2.37499 21.0006 2.24999 21.0506 2.12499 21.1006C1.87499 21.3256 1.77499 21.6506 1.69999 22.1006C1.67499 22.2006 1.67499 22.3006 1.64999 22.4256C1.47499 23.9506 1.32499 25.4756 1.14999 27.0256C1.09999 27.4006 1.39999 27.7256 1.77499 27.7256C3.34999 27.7256 7.39999 27.7256 11.425 27.7256C15.45 27.7256 19.5 27.7256 21.075 27.7256C21.45 27.7506 21.75 27.4256 21.7 27.0506Z"
      fill="#151515"
    />
  </svg>
);

export const BagpackFillIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-backpack4-fill dashboard-card-icon"
    viewBox="0 0 16 16"
    style={{ color: "#4E9F3D" }}
  >
    <path d="M8 0a2 2 0 0 0-2 2H3.5a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h4v.5a.5.5 0 0 0 1 0V7h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H10a2 2 0 0 0-2-2m1 2a1 1 0 0 0-2 0zm-4 9v2h6v-2h-1v.5a.5.5 0 0 1-1 0V11z" />
    <path d="M14 7.599A3 3 0 0 1 12.5 8H9.415a1.5 1.5 0 0 1-2.83 0H3.5A3 3 0 0 1 2 7.599V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5z" />
  </svg>
);

export const ThreeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-3-circle-fill"
    viewBox="0 0 16 16"
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-8.082.414c.92 0 1.535.54 1.541 1.318.012.791-.615 1.36-1.588 1.354-.861-.006-1.482-.469-1.54-1.066H5.104c.047 1.177 1.05 2.144 2.754 2.144 1.653 0 2.954-.937 2.93-2.396-.023-1.278-1.031-1.846-1.734-1.916v-.07c.597-.1 1.505-.739 1.482-1.876-.03-1.177-1.043-2.074-2.637-2.062-1.675.006-2.59.984-2.625 2.12h1.248c.036-.556.557-1.054 1.348-1.054.785 0 1.348.486 1.348 1.195.006.715-.563 1.237-1.342 1.237h-.838v1.072h.879Z" />
  </svg>
);

export const StarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z" />
  </svg>
);

export const AppleIcon = ({ color = "currentColor" }) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Apple</title>
    <g
      id="Apple"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <path
        d="M15.8415441,6.74869934 C16.8885878,6.67700744 17.9129044,7.07687119 18.634459,7.83897305 C19.3109361,8.55346438 19.6925726,9.49368987 19.7090444,10.4720458 L19.7063314,10.6984117 L19.680556,11.329963 C19.625485,12.6793199 19.4084052,14.0165446 19.034416,15.3129364 L18.8868249,15.7971133 L18.5196685,16.9397515 C18.0675637,18.3467602 16.9447629,19.4364248 15.5248458,19.8461907 C14.9219814,20.0201679 14.1005014,19.9826975 13.0604059,19.7337796 L12.7713255,19.660642 C12.2657464,19.5260996 11.7337722,19.5261116 11.2281991,19.6606768 C10.0504876,19.9741407 9.13280596,20.0359787 8.47515416,19.8461907 C7.05523713,19.4364248 5.93243632,18.3467602 5.48033148,16.9397515 L5.11317509,15.7971133 C4.6483962,14.3506613 4.38139884,12.8479895 4.31944398,11.329963 L4.29366863,10.6984117 C4.25045868,9.63967565 4.63702715,8.60842525 5.36554102,7.83897305 C6.08709562,7.07687119 7.1114122,6.67700744 8.15845592,6.74869934 L8.77655188,6.79102085 C9.66526257,6.85187156 10.7399657,7.50407763 12.0006614,8.74763906 C13.1675406,7.56251015 14.1638735,6.91787825 14.98966,6.81374335 L15.2234481,6.79102085 L15.8415441,6.74869934 Z M12,8 C12,6.20842913 13.1464165,4.61786116 14.8460499,4.0513167 L15,4 M12,8 L12,5.45941171 C12,4.02936865 10.990621,2.7981242 9.58834841,2.51766968 L7,2 L7,2.54058829 C7,3.97063135 8.009379,5.2018758 9.41165159,5.48233032 L12,6"
        id="Combined-Shape"
        stroke={color}
      ></path>
    </g>
  </svg>
);

export const ScaleIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.04 14.4892C16.628 14.8201 17.2979 15 17.9985 15C18.6992 15 19.3691 14.8201 19.957 14.4892L17.9985 9.10267ZM5.99854 9.10267L4.04004 14.4892C4.62795 14.8201 5.29792 15 5.99854 15C6.69916 15 7.36912 14.8201 7.95703 14.4892L5.99854 9.10267Z" />
  </svg>
);

export const BreadIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M1 7C1 4.79086 2.79086 3 5 3H7C4.79086 3 3 4.79086 3 7C3 8.48168 3.8052 9.77343 5 10.4646V19C5 20.6569 6.34315 22 8 22H6C4.34315 22 3 20.6569 3 19V10.4646C1.8052 9.77343 1 8.48168 1 7ZM8 22V20C7.44772 20 7 19.5523 7 19V9.12212L6.33325 8.88645C5.5551 8.61142 5 7.86925 5 7C5 5.89543 5.89543 5 7 5V3H19C21.2091 3 23 4.79086 23 7C23 8.48168 22.1948 9.77343 21 10.4646V19C21 20.6569 19.6569 22 18 22H8Z" />
  </svg>
);

export const AvocadoIcon = ({ color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill={color}
    viewBox="0 0 256 256"
  >
    <path d="M128,112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,112Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,192Zm83-61.34L181.2,46.47a56,56,0,0,0-106-1.14h0l-29.51,83.5A88,88,0,1,0,211,130.66ZM128,232a72.05,72.05,0,0,1-67.33-97.57,1.34,1.34,0,0,1,.07-.18L90.28,50.66h0a40,40,0,0,1,75.74.88l.06.18L195.9,136A72.05,72.05,0,0,1,128,232Z" />
  </svg>
);

export const BeconIcon = ({ color = "#3C1146" }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512.001 512.001"
    style={{ enableBackground: "new 0 0 512.001 512.001" }}
    xmlSpace="preserve"
  >
    <path
      style={{ fill: "#D4A8B4" }}
      d="M460.732,164.757c-7.853-11.68-17.788-21.861-29.285-29.959
	c-18.707-13.211-41.516-20.957-66.162-20.957H146.703c-31.718,0-60.438,12.859-81.226,33.649S31.83,196.997,31.83,228.732
	c0,4.653,2.021,8.848,5.235,11.727c2.786,2.526,6.49,4.056,10.548,4.056h416.779c4.363,0,8.297-1.776,11.159-4.623
	c2.847-2.863,4.623-6.799,4.623-11.161C480.173,205.047,473.009,183.035,460.732,164.757z M43.505,243.57
	c-0.619-3.244-0.956-6.587-0.956-10.011c0-29.315,23.764-53.081,53.078-53.081s53.078,23.766,53.078,53.081
	c0,3.422-0.337,6.767-0.956,10.011L43.505,243.57L43.505,243.57z M253.905,243.57H149.661c-0.619-3.244-0.956-6.587-0.956-10.011
	c0-29.315,23.764-53.081,53.078-53.081s53.078,23.766,53.078,53.081C254.862,236.983,254.525,240.328,253.905,243.57z"
    />
    <g>
      <path
        style={{ fill: color }}
        d="M464.391,257.835H47.612c-7.23,0-14.153-2.666-19.495-7.508c-6.087-5.45-9.61-13.341-9.61-21.597
		c0-34.248,13.335-66.446,37.549-90.662c24.216-24.216,56.408-37.551,90.647-37.551h218.581c26.638,0,52.174,8.09,73.848,23.398
		c12.846,9.047,23.836,20.29,32.656,33.406c14.203,21.146,21.707,45.837,21.707,71.408c0,7.744-3.019,15.044-8.499,20.555
		C479.432,254.818,472.134,257.835,464.391,257.835z M268.141,231.192H464.39c0.839,0,1.424-0.406,1.766-0.747
		c0.288-0.29,0.694-0.875,0.694-1.714c0-20.261-5.94-39.815-17.179-56.546c-6.994-10.404-15.709-19.319-25.898-26.496
		c-17.167-12.125-37.388-18.527-58.492-18.527H146.703c-27.123,0-52.624,10.565-71.808,29.747
		c-6.577,6.577-12.14,13.898-16.612,21.773c10.647-7.268,23.508-11.522,37.344-11.522c21.671,0,40.952,10.436,53.078,26.547
		c12.127-16.111,31.407-26.547,53.078-26.547C237.602,167.158,266.89,195.672,268.141,231.192z M162.163,230.249h79.24
		c-1.688-20.381-18.813-36.448-39.621-36.448S163.849,209.87,162.163,230.249z M56.007,230.249h79.24
		c-1.688-20.381-18.813-36.448-39.619-36.448C74.819,193.801,57.693,209.87,56.007,230.249z"
      />
      <path
        style={{ fill: color }}
        d="M427.722,411.487H84.279c-10.48,0-20.326-4.629-27.013-12.698L8.121,339.482
		c-8.766-10.579-10.581-24.875-4.736-37.309c5.844-12.434,18.011-20.158,31.749-20.158h259.317c7.357,0,13.321,5.965,13.321,13.321
		s-5.964,13.321-13.321,13.321H35.135c-4.836,0-6.952,3.392-7.637,4.849c-0.686,1.459-1.946,5.251,1.139,8.975l49.144,59.307
		c1.609,1.942,3.978,3.056,6.498,3.056h343.443c2.52,0,4.889-1.114,6.498-3.056l49.144-59.307c3.085-3.723,1.825-7.517,1.139-8.975
		c-0.685-1.457-2.802-4.849-7.637-4.849h-98.247c-7.357,0-13.321-5.965-13.321-13.321c0-7.356,5.964-13.321,13.321-13.321h98.247
		c13.738,0,25.905,7.724,31.749,20.158c5.845,12.434,4.03,26.73-4.737,37.309l-49.143,59.307
		C448.048,406.86,438.202,411.487,427.722,411.487z"
      />
      <path
        style={{ fill: color }}
        d="M112.763,192.499c-3.409,0-6.819-1.302-9.42-3.902c-5.202-5.202-5.202-13.637,0-18.841
		l65.342-65.342c5.202-5.201,13.637-5.201,18.841,0c5.202,5.202,5.202,13.637,0,18.841l-65.342,65.342
		C119.582,191.197,116.172,192.499,112.763,192.499z"
      />
      <path
        style={{ fill: color }}
        d="M248.064,212.633c-3.409,0-6.819-1.302-9.42-3.902c-5.202-5.202-5.202-13.637,0-18.841
		l85.476-85.476c5.202-5.201,13.637-5.201,18.841,0c5.202,5.202,5.202,13.637,0,18.841l-85.476,85.476
		C254.883,211.331,251.473,212.633,248.064,212.633z"
      />
      <path
        style={{ fill: color }}
        d="M358.287,257.83c-3.409,0-6.819-1.302-9.42-3.902c-5.202-5.202-5.202-13.637,0-18.841l92.5-92.5
		c5.202-5.201,13.637-5.201,18.841,0c5.202,5.202,5.202,13.637,0,18.841l-92.5,92.5C365.106,256.528,361.696,257.83,358.287,257.83z
		"
      />
    </g>
  </svg>
);

export const MultiImageIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M6 4C6 3.44772 6.44772 3 7 3H21C21.5523 3 22 3.44772 22 4V16C22 16.5523 21.5523 17 21 17H18V20C18 20.5523 17.5523 21 17 21H3C2.44772 21 2 20.5523 2 20V8C2 7.44772 2.44772 7 3 7H6V4ZM8 7H17C17.5523 7 18 7.44772 18 8V15H20V5H8V7ZM16 15.7394V9H4V18.6321L11.4911 11.6404L16 15.7394ZM7 13.5C7.82843 13.5 8.5 12.8284 8.5 12C8.5 11.1716 7.82843 10.5 7 10.5C6.17157 10.5 5.5 11.1716 5.5 12C5.5 12.8284 6.17157 13.5 7 13.5Z" />
  </svg>
);

export const VideoIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M17 9.2L22.2133 5.55071C22.4395 5.39235 22.7513 5.44737 22.9096 5.6736C22.9684 5.75764 23 5.85774 23 5.96033V18.0397C23 18.3158 22.7761 18.5397 22.5 18.5397C22.3974 18.5397 22.2973 18.5081 22.2133 18.4493L17 14.8V19C17 19.5523 16.5523 20 16 20H2C1.44772 20 1 19.5523 1 19V5C1 4.44772 1.44772 4 2 4H16C16.5523 4 17 4.44772 17 5V9.2Z" />
  </svg>
);

export const BiBoxArrowUpRightIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-box-arrow-up-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
    />
    <path
      fillRule="evenodd"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
    />
  </svg>
);

export const TagIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M10.9042 2.10025L20.8037 3.51446L22.2179 13.414L13.0255 22.6063C12.635 22.9969 12.0019 22.9969 11.6113 22.6063L1.71184 12.7069C1.32131 12.3163 1.32131 11.6832 1.71184 11.2926L10.9042 2.10025ZM11.6113 4.22157L3.83316 11.9997L12.3184 20.485L20.0966 12.7069L19.036 5.28223L11.6113 4.22157ZM13.7327 10.5855C12.9516 9.80448 12.9516 8.53815 13.7327 7.7571C14.5137 6.97606 15.78 6.97606 16.5611 7.7571C17.3421 8.53815 17.3421 9.80448 16.5611 10.5855C15.78 11.3666 14.5137 11.3666 13.7327 10.5855Z" />
  </svg>
);

export const BiBanIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-ban"
    viewBox="0 0 16 16"
    style={{
      color: "gray",
      width: "25px",
      height: "25px",
      cursor: "not-allowed",
    }}
  >
    <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" />
  </svg>
);

export const BiDashSquareDottedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-dash-square-dotted"
    viewBox="0 0 16 16"
  >
    <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834 0h.916v-1h-.916zm1.833 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z" />
  </svg>
);

export const BiPlusSquareDottedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-plus-square-dotted"
    viewBox="0 0 16 16"
  >
    <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834-1v1h.916v-1zm1.833 1h.917v-1h-.917zm1.833 0h.917v-1h-.917zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
  </svg>
);

export const WhatsAppIconIcon = ({ color = "#13CE66" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M9.67148 24.6585L10.6378 25.222C12.2521 26.1633 14.0868 26.666 16.0013 26.666C21.8924 26.666 26.668 21.8904 26.668 15.9993C26.668 10.1083 21.8924 5.33268 16.0013 5.33268C10.1103 5.33268 5.33464 10.1083 5.33464 15.9993C5.33464 17.9144 5.83761 19.7497 6.77954 21.3644L7.34272 22.3297L6.4714 25.5319L9.67148 24.6585ZM2.67354 29.3327L4.47616 22.708C3.32658 20.7375 2.66797 18.4453 2.66797 15.9993C2.66797 8.63555 8.6375 2.66602 16.0013 2.66602C23.3651 2.66602 29.3347 8.63555 29.3347 15.9993C29.3347 23.3631 23.3651 29.3327 16.0013 29.3327C13.5561 29.3327 11.2647 28.6745 9.29448 27.5256L2.67354 29.3327ZM11.1898 9.74379C11.3683 9.73124 11.5474 9.72932 11.7261 9.73804C11.7983 9.74279 11.8702 9.75113 11.9421 9.75944C12.1545 9.78396 12.388 9.91328 12.4665 10.0913C12.8642 10.9932 13.2502 11.9002 13.6243 12.8122C13.7068 13.0135 13.6571 13.2745 13.5 13.5269C13.4203 13.6564 13.295 13.838 13.15 14.0237C12.9992 14.2167 12.6746 14.5715 12.6746 14.5715C12.6746 14.5715 12.5432 14.7291 12.5927 14.9252C12.612 14.9993 12.6736 15.1073 12.7294 15.1981C12.7604 15.2484 12.7891 15.2933 12.8077 15.3244C13.1489 15.8941 13.6076 16.4717 14.1679 17.0148C14.3284 17.1704 14.4841 17.3292 14.6516 17.4767C15.276 18.0272 15.9824 18.4771 16.7453 18.8103L16.7521 18.8133C16.8648 18.8619 16.9227 18.8884 17.0876 18.9584C17.1708 18.9936 17.2559 19.024 17.3432 19.0471C17.3748 19.0553 17.4072 19.06 17.4397 19.0623C17.6553 19.0752 17.78 18.9369 17.8332 18.8733C18.7979 17.7047 18.8861 17.6284 18.8928 17.6289V17.6311C19.0196 17.4975 19.2189 17.4511 19.3968 17.462C19.478 17.4669 19.5588 17.4825 19.6327 17.5163C20.3417 17.8397 21.5011 18.3443 21.5011 18.3443L22.2764 18.6928C22.4063 18.7555 22.5248 18.9031 22.5305 19.0465C22.534 19.1357 22.5436 19.2797 22.5117 19.5432C22.47 19.8881 22.3651 20.3035 22.2608 20.5211C22.1875 20.6737 22.0925 20.8092 21.9821 20.9239C21.8324 21.0793 21.7212 21.1737 21.5412 21.3079C21.4316 21.3895 21.3748 21.4279 21.3748 21.4279C21.1896 21.5447 21.0852 21.6031 20.8645 21.7205C20.5213 21.9033 20.1421 22.0084 19.7537 22.0284C19.5061 22.0411 19.2592 22.0589 19.0119 22.0456C19.0009 22.0449 18.2543 21.9303 18.2543 21.9303C16.3584 21.4316 14.6051 20.4975 13.1338 19.202C12.833 18.9372 12.554 18.6507 12.2692 18.3672C11.0838 17.1871 10.1864 15.9145 9.64225 14.7108C9.3739 14.1172 9.20398 13.4815 9.2013 12.8273C9.19638 12.0181 9.46132 11.2303 9.95425 10.5885C10.0514 10.462 10.1436 10.3307 10.3028 10.1805C10.4713 10.0214 10.5786 9.93594 10.6941 9.87683C10.8481 9.79804 11.0172 9.75591 11.1898 9.74379Z"
      fill={color}
    />
  </svg>
);

export const BiImageIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-image"
    viewBox="0 0 16 16"
  >
    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
  </svg>
);

export const BiArrowUpIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-arrow-up"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
    />
  </svg>
);

export const BiArrowDownIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-arrow-down"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
    />
  </svg>
);

export const SourceIcon = ({
  size = 24,
  stroke = "currentColor",
  fill = "none",
  className = "",
  ...props
}) => (
  <svg
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <ellipse cx="12" cy="5" rx="7" ry="3" stroke={stroke} strokeWidth="1.5" />
    <path
      d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IdIcon = ({ color = "currentColor" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M2 4C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2ZM9.00008 10C9.00008 9.44772 8.55236 9 8.00008 9C7.44779 9 7.00008 9.44772 7.00008 10C7.00008 10.5523 7.44779 11 8.00008 11C8.55236 11 9.00008 10.5523 9.00008 10ZM11.0001 10C11.0001 11.6569 9.65693 13 8.00008 13C6.34322 13 5.00008 11.6569 5.00008 10C5.00008 8.34315 6.34322 7 8.00008 7C9.65693 7 11.0001 8.34315 11.0001 10ZM5.52725 17.0251L4.11304 15.6109C5.10725 14.6167 6.48362 14 8.00212 14C9.52063 14 10.897 14.6167 11.8912 15.6109L10.477 17.0251C9.84253 16.3907 8.9689 16 8.00212 16C7.03535 16 6.16172 16.3907 5.52725 17.0251ZM20.2071 10.7071L16.2071 14.7071L15.5 15.4142L14.7929 14.7071L12.2929 12.2071L13.7071 10.7929L15.5 12.5858L18.7929 9.29289L20.2071 10.7071Z" />
  </svg>
);

export const MobileIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-phone-fill"
    viewBox="0 0 16 16"
  >
    <path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
  </svg>
);

export const LiveIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={color}
    width="24"
    height="24"
  >
    <circle cx="12" cy="12" r="10" stroke={color} fill="none" strokeWidth="2" />
    <circle cx="12" cy="12" r="3" fill={color} />
  </svg>
);

export const PTIcon1 = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={color}
    width="24"
    height="24"
  >
    <path d="M20 22H18V20C18 18.3431 16.6569 17 15 17H9C7.34315 17 6 18.3431 6 20V22H4V20C4 17.2386 6.23858 15 9 15H15C17.7614 15 20 17.2386 20 20V22ZM12 13C8.68629 13 6 10.3137 6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7C18 10.3137 15.3137 13 12 13ZM12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" />
  </svg>
);

export const BoltIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={color}
    width="24"
    height="24"
  >
    <path d="M13 9H21L11 24V15H4L13 0V9ZM11 11V7.22063L7.53238 13H13V17.3944L17.263 11H11Z" />
  </svg>
);

export const ViewListIcon = ({ color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-view-list"
    viewBox="0 0 16 16"
  >
    <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
  </svg>
);
// Ported from main (WTF Gyms) — used by Trainers Rating page (TrainersRatingStats)
export const RatingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-star"
    viewBox="0 0 16 16"
  >
    <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
  </svg>
);

export const GymIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="9,22 9,12 15,12 15,22"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// --- Offer module icons (ported from main for All Gym Offers) ---
export const DumbleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-dumbbell-icon lucide-dumbbell"
  >
    <path d="M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z" />
    <path d="m2.5 21.5 1.4-1.4" />
    <path d="m20.1 3.9 1.4-1.4" />
    <path d="M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z" />
    <path d="m9.6 14.4 4.8-4.8" />
  </svg>
);

export const TrophyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-trophy-icon lucide-trophy"
  >
    <path d="M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978" />
    <path d="M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978" />
    <path d="M18 9h1.5a1 1 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z" />
    <path d="M6 9H4.5a1 1 0 0 1 0-5H6" />
  </svg>
);

export const LightningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-zap-icon lucide-zap"
  >
    <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
  </svg>
);

// CopyIcon (ported from main for WTF Banners duplicate action)
export const CopyIcon = ({ color = "#374151" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill={color}
    className="bi bi-copy"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
    />
  </svg>
);
